/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_freeGlobal.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** Detect free variable `global` from Node.js. */
/**
 * https://stackoverflow.com/questions/17575790/environment-detection-node-js-or-browser
 */
/** @type {?} */
const isNode = new Function('try {return this===global;}catch(e){return false;}');
// tests if global scope is binded to "global"
// if(isNode()) console.log("running under node.js");
/** @type {?} */
const getGlobal = new Function(`try {
          if (this === global) {
            return global;
          } else {
            return null;
          }
        } catch (e) {
          return null;
        }`);
/** @type {?} */
let freeGlobal = isNode() ? getGlobal() : null;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_root.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// /** Detect free variable `self`. */
/** @type {?} */
const freeSelf = typeof self === 'object' && self && self['Object'] === Object && self;
/**
 * Used as a reference to the global _object.
 * @type {?}
 */
let root = freeGlobal || freeSelf || Function('return this')();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/symbol.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const symbol = root.Symbol;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getRawTag.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 * @type {?}
 */
const nativeObjectToString = objectProto.toString;
/**
 * Built-in value references.
 * @type {?}
 */
const symToStringTag = symbol ? symbol['toStringTag'] : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * Returns the raw `toStringTag`.
 *
 * @param {?} value The value to query.
 * @return {?}
 */
function getRawTag(value) {
    /** @type {?} */
    const isOwn = hasOwnProperty.call(value, symToStringTag);
    /** @type {?} */
    const tag = value[symToStringTag];
    /** @type {?} */
    let unmasked;
    try {
        value[symToStringTag] = undefined;
        unmasked = true;
    }
    catch (e) { }
    /** @type {?} */
    const result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_objectToString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 * @type {?}
 */
const nativeObjectToString$1 = objectProto$1.toString;
/**
 * Converts `value` to a _string using `Object.prototype.toString`.
 *
 * Returns the converted _string.
 *
 * @param {?} value The value to convert.
 * @return {?}
 */
function objectToString(value) {
    return nativeObjectToString$1.call(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseGetTag.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const nullTag = '[object Null]';
/** @type {?} */
const undefinedTag = '[object Undefined]';
/**
 * Built-in value references.
 * @type {?}
 */
const symToStringTag$1 = symbol ? symbol['toStringTag'] : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 * @param {?} value The value to query.
 * @return {?}
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 *
 * @param {?} value
 * @return {?}
 */
function isObject(value) {
    /** @type {?} */
    const type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isFunction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const asyncTag = '[object AsyncFunction]';
/** @type {?} */
const funcTag = '[object Function]';
/** @type {?} */
const genTag = '[object GeneratorFunction]';
/** @type {?} */
const proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` _object.
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 * @param {?} value
 * @return {?}
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    /** @type {?} */
    const tag = baseGetTag(value);
    return tag === funcTag || tag === genTag || tag === asyncTag || tag === proxyTag;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isObjectLike.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is _object-like. A value is _object-like if it's not `null`
 * and has a `typeof` result of "_object".
 *
 *
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 *
 * @param {?} value
 * @return {?}
 */
function isObjectLike(value) {
    return value != null && typeof value === 'object';
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isBoolean.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or _object.
 *
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 *
 * @param {?} value
 * Returns `true` if `value` is a boolean, else `false`.
 * @return {?}
 */
function isBoolean(value) {
    return value === true || value === false || (isObjectLike(value) && baseGetTag(value) === boolTag);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsDate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const dateTag = '[object Date]';
/**
 * The base implementation of `_.isDate` without Node optimizations.
 * @param {?} value The value to check.
 * @return {?}
 */
function baseIsDate(value) {
    return isObjectLike(value) && baseGetTag(value) === dateTag;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseUnary.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.unary` without support for storing metadata.
 * Returns the new capped function.
 *
 * @param {?} func The function to cap arguments for.
 * @return {?}
 */
function baseUnary(func) {
    return (/**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return func(value);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_nodeUtil.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const isNode$1 = new Function('try {return this===global;}catch(e){return false;}');
// const getExports: Function = new Function('return exports');
/** @type {?} */
const getExports = new Function(`try {
          if (exports) {
            return exports;
          } else {
            return null;
          }
        } catch (e) {
          return null;
        }`);
/** @type {?} */
const getModule = new Function('return module');
/**
 * Detect free variable `exports`.
 * @type {?}
 */
const freeExports = isNode$1() && typeof getExports() === 'object' && !(getExports() && getExports().nodeType) ? getExports() : null;
// declare const module;
/**
 * Detect free variable `module`.
 * @type {?}
 */
const freeModule = isNode$1() && freeExports && typeof getModule() === 'object' && !getModule().nodeType ? getModule() : null;
/**
 * Detect the popular CommonJS extension `module.exports`.
 * @type {?}
 */
const moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Detect free variable `process` from Node.js.
 * @type {?}
 */
const freeProcess = moduleExports && freeGlobal.process;
const ɵ0 = /**
 * @return {?}
 */
function () {
    try {
        // Use `util.types` for Node.js 10+.
        /** @type {?} */
        const types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
            return types;
        }
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    }
    catch (e) { }
};
/**
 * Used to access faster Node.js helpers.
 * @type {?}
 */
const nodeUtil = ((ɵ0))();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isDate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const nodeIsDate = nodeUtil && nodeUtil.isDate;
/**
 * Checks if `value` is classified as a `Date` _object.
 *
 * \@param value The value to check.
 * Returns `true` if `value` is a _date _object, else `false`.
 *
 * isDate(new Date);
 * // => true
 *
 * isDate('Mon April 23 2012');
 * // => false
 * @type {?}
 */
const isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isPrototype.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$2 = Object.prototype;
/**
 * Checks if `value` is likely a prototype _object.
 * Returns `true` if `value` is a prototype, else `false`.
 *
 * @param {?} value The value to check.
 * @return {?}
 */
function isPrototype(value) {
    /** @type {?} */
    const Ctor = value && value.constructor;
    /** @type {?} */
    const proto = (typeof Ctor === 'function' && Ctor.prototype) || objectProto$2;
    return value === proto;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_overArg.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * Returns the new function.
 *
 * @param {?} func The function to wrap.
 * @param {?} transform The argument transform.
 * @return {?}
 */
function overArg(func, transform) {
    return (/**
     * @param {?} arg
     * @return {?}
     */
    function (arg) {
        return func(transform(arg));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_nativeKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references for those with the same name as other methods. */
/** @type {?} */
const nativeKeys = overArg(Object.keys, Object);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$3 = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$1 = objectProto$3.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 * Returns the _array of property names.
 * @param {?} object The _object to query.
 * @return {?}
 */
function baseKeys(object) {
    if (!isPrototype(object)) {
        return nativeKeys(object);
    }
    /** @type {?} */
    const result = [];
    for (const key in Object(object)) {
        if (hasOwnProperty$1.call(object, key) && key !== 'constructor') {
            result.push(key);
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_coreJsData.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to detect overreaching core-js shims.
 * @type {?}
 */
const coreJsData = root['__core-js_shared__'];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isMasked.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$1 = /**
 * @return {?}
 */
function () {
    /** @type {?} */
    const uid = /[^.]+$/.exec((coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
};
/**
 * Used to detect methods masquerading as native.
 * @type {?}
 */
const maskSrcKey = ((ɵ0$1))();
/**
 * Checks if `func` has its source masked.
 *
 * Returns `true` if `func` is masked, else `false`.
 * @param {?} func The function to check.
 * @return {?}
 */
function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_toSource.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const funcProto = Function.prototype;
/**
 * Used to resolve the decompiled source of functions.
 * @type {?}
 */
const funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * Returns the source code.
 *
 * @param {?} func The function to convert.
 * @return {?}
 */
function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        }
        catch (e) { }
        try {
            return func + '';
        }
        catch (e) { }
    }
    return '';
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsNative.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/**
 * Used to detect host constructors (Safari).
 * @type {?}
 */
const reIsHostCtor = /^\[object .+?Constructor\]$/;
/**
 * Used for built-in method references.
 * @type {?}
 */
const funcProto$1 = Function.prototype;
/** @type {?} */
const objectProto$4 = Object.prototype;
/**
 * Used to resolve the decompiled source of functions.
 * @type {?}
 */
const funcToString$1 = funcProto$1.toString;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$2 = objectProto$4.hasOwnProperty;
/**
 * Used to detect if a method is native.
 * @type {?}
 */
const reIsNative = RegExp('^' +
    funcToString$1
        .call(hasOwnProperty$2)
        .replace(reRegExpChar, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
    '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 * Returns `true` if `value` is a native function,
 *  else `false`.
 * @param {?} value The value to check.
 * @return {?}
 */
function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
        return false;
    }
    /** @type {?} */
    const pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the value at `key` of `_object`.
 *
 * Returns the property value.
 *
 * @param {?} object The _object to query.
 *  key The key of the property to get.
 * @param {?} key
 * @return {?}
 */
function getValue(object, key) {
    return object == null ? undefined : object[key];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getNative.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the native function at `key` of `_object`.
 *
 *
 * @param {?} object The _object to query.
 *  key The key of the method to get.
 * Returns the function if it's native, else `undefined`.
 * @param {?} key
 * @return {?}
 */
function getNative(object, key) {
    /** @type {?} */
    const value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_DataView.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const dataView = getNative(root, 'DataView');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/map.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const map = getNative(root, 'Map');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/promise.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const promise = getNative(root, 'Promise');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Set.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const Set = getNative(root, 'Set');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_WeakMap.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const weakMap = getNative(root, 'WeakMap');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getTag.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const mapTag = '[object Map]';
/** @type {?} */
const objectTag = '[object Object]';
/** @type {?} */
const promiseTag = '[object Promise]';
/** @type {?} */
const setTag = '[object Set]';
/** @type {?} */
const weakMapTag = '[object WeakMap]';
/** @type {?} */
const dataViewTag = '[object DataView]';
/**
 * Used to detect maps, sets, and weakmaps.
 * @type {?}
 */
const dataViewCtorString = toSource(dataView);
/** @type {?} */
const mapCtorString = toSource(map);
/** @type {?} */
const promiseCtorString = toSource(promise);
/** @type {?} */
const setCtorString = toSource(Set);
/** @type {?} */
const weakMapCtorString = toSource(weakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 *
 * \@param value The value to query.
 * Returns the `toStringTag`.
 * @type {?}
 */
let getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node < 6.
if ((dataView && getTag(new dataView(new ArrayBuffer(1))) !== dataViewTag) ||
    (map && getTag(new map()) !== mapTag) ||
    (promise && getTag(promise.resolve()) !== promiseTag) ||
    (Set && getTag(new Set()) !== setTag) ||
    (weakMap && getTag(new weakMap()) !== weakMapTag)) {
    getTag = (/**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        const result = baseGetTag(value);
        /** @type {?} */
        const Ctor = result === objectTag ? value.constructor : undefined;
        /** @type {?} */
        const ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsArguments.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 * Returns `true` if `value` is an `arguments` _object,
 * @param {?} value The value to check.
 * @return {?}
 */
function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) === argsTag;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isArguments.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const objectProto$5 = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$3 = objectProto$5.hasOwnProperty;
/**
 * Built-in value references.
 * @type {?}
 */
const propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` _object.
 *
 * Returns `true` if `value` is an `arguments` _object,
 *  else `false`.
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 * @type {?}
 */
const isArguments = baseIsArguments(((/**
 * @return {?}
 */
function () {
    return arguments;
}))())
    ? baseIsArguments
    : (/**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return isObjectLike(value) && hasOwnProperty$3.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if value is classified as an Array _object.
 * \@param value: any
 * @type {?}
 */
const isArray = Array.isArray;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isLength.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid _array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 * @param {?} value
 * @return {?}
 */
function isLength(value) {
    return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isArrayLike.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is _array-like. A value is considered _array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * Returns `true` if `value` is _array-like, else `false`.
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 *
 * @param {?} value
 * @return {?}
 */
function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/stubFalse.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method returns `false`.
 *
 * Returns `false`.
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 * @return {?}
 */
function stubFalse() {
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isBuffer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const freeExports$1 = typeof exports === 'object' && exports && !exports.nodeType && exports;
/**
 * Detect free variable `module`.
 * @type {?}
 */
const freeModule$1 = freeExports$1 && typeof module === 'object' && module && !module['nodeType'] && module;
/**
 * Detect the popular CommonJS extension `module.exports`.
 * @type {?}
 */
const moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/**
 * Built-in value references.
 * @type {?}
 */
const Buffer = moduleExports$1 ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other methods. */
/** @type {?} */
const nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * \@param value The value to check.
 * Returns `true` if `value` is a buffer, else `false`.
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 * @type {?}
 */
const isBuffer = nativeIsBuffer || stubFalse;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsTypedArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const argsTag$1 = '[object Arguments]';
/** @type {?} */
const arrayTag = '[object Array]';
/** @type {?} */
const boolTag$1 = '[object Boolean]';
/** @type {?} */
const dateTag$1 = '[object Date]';
/** @type {?} */
const errorTag = '[object Error]';
/** @type {?} */
const funcTag$1 = '[object Function]';
/** @type {?} */
const mapTag$1 = '[object Map]';
/** @type {?} */
const numberTag = '[object Number]';
/** @type {?} */
const objectTag$1 = '[object Object]';
/** @type {?} */
const regexpTag = '[object RegExp]';
/** @type {?} */
const setTag$1 = '[object Set]';
/** @type {?} */
const stringTag = '[object String]';
/** @type {?} */
const weakMapTag$1 = '[object WeakMap]';
/** @type {?} */
const arrayBufferTag = '[object ArrayBuffer]';
/** @type {?} */
const dataViewTag$1 = '[object DataView]';
/** @type {?} */
const float32Tag = '[object Float32Array]';
/** @type {?} */
const float64Tag = '[object Float64Array]';
/** @type {?} */
const int8Tag = '[object Int8Array]';
/** @type {?} */
const int16Tag = '[object Int16Array]';
/** @type {?} */
const int32Tag = '[object Int32Array]';
/** @type {?} */
const uint8Tag = '[object Uint8Array]';
/** @type {?} */
const uint8ClampedTag = '[object Uint8ClampedArray]';
/** @type {?} */
const uint16Tag = '[object Uint16Array]';
/** @type {?} */
const uint32Tag = '[object Uint32Array]';
/**
 * Used to identify `toStringTag` values of typed arrays.
 * @type {?}
 */
const typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 * Returns `true` if `value` is a typed _array, else `false`.
 * @param {?} value The value to check.
 * @return {?}
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isTypedArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed _array.
 *
 * \@param value The value to check.
 * Returns `true` if `value` is a typed _array, else `false`.
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 * @type {?}
 */
const isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isEmpty.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const mapTag$2 = '[object Map]';
/** @type {?} */
const setTag$2 = '[object Set]';
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$6 = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$4 = objectProto$6.hasOwnProperty;
/**
 * Checks if `value` is an empty _object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable _string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @param {?} value The value to check.
 * Returns `true` if `value` is empty, else `false`.
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 * @return {?}
 */
function isEmpty(value) {
    if (value == null) {
        return true;
    }
    if (isArrayLike(value) &&
        (isArray(value) ||
            typeof value === 'string' ||
            typeof value.splice === 'function' ||
            isBuffer(value) ||
            isTypedArray(value) ||
            isArguments(value))) {
        return !value.length;
    }
    /** @type {?} */
    const tag = getTag(value);
    if (tag === mapTag$2 || tag === setTag$2) {
        return !value.size;
    }
    if (isPrototype(value)) {
        return !baseKeys(value).length;
    }
    for (const key in value) {
        if (hasOwnProperty$4.call(value, key)) {
            return false;
        }
    }
    return true;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isNumber.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const numberTag$1 = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or _object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @param {?} value The value to check.
 * Returns `true` if `value` is a _number, else `false`.
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 * @return {?}
 */
function isNumber(value) {
    return ((!isNaN(value - parseFloat(value)) && typeof value === 'number') ||
        (isObjectLike(value) && baseGetTag(value) === numberTag$1));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const stringTag$1 = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or _object.
 *
 * @param {?} value The value to check.
 * Returns `true` if `value` is a _string, else `false`.
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 * @return {?}
 */
function isString(value) {
    return typeof value === 'string' || (!isArray(value) && isObjectLike(value) && baseGetTag(value) === stringTag$1);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function hasValue(value) {
    if (isDate(value)) {
        return value.toJSON().length > 0;
    }
    else if (isString(value)) {
        return !isEmpty(value);
    }
    else if (isNumber(value)) {
        return true; // true for all numbers
    }
    else if (isBoolean(value)) {
        // Testing for value, not truthy
        return true;
    }
    else if (isFunction(value)) {
        // Testing for value, not truthy
        return true;
    }
    else {
        return !isEmpty(value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_collection/collectionItemsHaveValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} collection
 * @return {?}
 */
function collectionItemsHaveValue(collection) {
    if (collection && collection.length > 0) {
        return collection.reduce((/**
         * @param {?} _allPropsHaveValue
         * @param {?} item
         * @return {?}
         */
        (_allPropsHaveValue, item) => {
            if (!_allPropsHaveValue) {
                return _allPropsHaveValue;
            }
            return hasValue(item);
        }), true);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_collection/getRandomFromArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/**
 * @param {?} arr
 * @return {?}
 */
function getRandomFromArray(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_listCacheClear.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes all key-value entries from the list cache.
 *
 * \@memberOf ListCache
 * @return {?}
 */
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/eq.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * Returns `true` if the values are equivalent, else `false`.
 *
 * \@category Lang
 * @param {?} value The value to compare.
 * @param {?} other The other value to compare.
 *
 * var _object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(_object, _object);
 * // => true
 *
 * _.eq(_object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 * @return {?}
 */
function eq(value, other) {
    return value === other || (value !== value && other !== other);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_assocIndexOf.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the index at which the `key` is found in `_array` of key-value pairs.
 *
 * Returns the index of the matched value, else `-1`.
 *
 * @param {?} array The _array to inspect.
 * @param {?} key The key to search for.
 * @return {?}
 */
function assocIndexOf(array, key) {
    /** @type {?} */
    let length = array.length;
    while (length--) {
        if (eq(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_listCacheDelete.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const arrayProto = Array.prototype;
/**
 * Built-in value references.
 * @type {?}
 */
const splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * \@memberOf ListCache
 * @param {?} key The key of the value to remove.
 * Returns `true` if the entry was removed, else `false`.
 * @return {?}
 */
function listCacheDelete(key) {
    /** @type {?} */
    const data = this.__data__;
    /** @type {?} */
    const index = assocIndexOf(data, key);
    if (index < 0) {
        return false;
    }
    /** @type {?} */
    const lastIndex = data.length - 1;
    if (index === lastIndex) {
        data.pop();
    }
    else {
        splice.call(data, index, 1);
    }
    --this.size;
    return true;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_listCacheGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the list cache value for `key`.
 *
 * \@name get
 * \@memberOf ListCache
 * @param {?} key The key of the value to get.
 * Returns the entry value.
 * @return {?}
 */
function listCacheGet(key) {
    /** @type {?} */
    const data = this.__data__;
    /** @type {?} */
    const index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_listCacheHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if a list cache value for `key` exists.
 *
 * \@memberOf ListCache
 * @param {?} key The key of the entry to check.
 * Returns `true` if an entry for `key` exists, else `false`.
 * @return {?}
 */
function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_listCacheSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets the list cache `key` to `value`.
 *
 * \@memberOf ListCache
 * @param {?} key The key of the value to set.
 * @param {?} value The value to set.
 * Returns the list cache instance.
 * @return {?}
 */
function listCacheSet(key, value) {
    /** @type {?} */
    const data = this.__data__;
    /** @type {?} */
    const index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([key, value]);
    }
    else {
        data[index][1] = value;
    }
    return this;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_ListCache.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an list cache _object.
 *
 * @param {?=} entries The key-value pairs to cache.
 * @return {?}
 */
function ListCache(entries) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        /** @type {?} */
        const entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stackClear.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes all key-value entries from the stack.
 *
 * @return {?}
 */
function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stackDelete.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes `key` and its value from the stack.
 *
 * @param {?} key The key of the value to remove.
 * @return {?} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
    /** @type {?} */
    const data = this.__data__;
    /** @type {?} */
    const result = data['delete'](key);
    this.size = data.size;
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stackGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the stack value for `key`.
 *
 * @param {?} key The key of the value to get.
 * Returns the entry value.
 * @return {?}
 */
function stackGet(key) {
    return this.__data__.get(key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stackHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if a stack value for `key` exists.
 *
 * @param {?} key The key of the entry to check.
 * Returns `true` if an entry for `key` exists, else `false`.
 * @return {?}
 */
function stackHas(key) {
    return this.__data__.has(key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Map.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const Map = getNative(root, 'Map');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_nativeCreate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references that are verified to be native. */
/** @type {?} */
const nativeCreate = getNative(Object, 'create');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hashClear.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes all key-value entries from the hash.
 * \@memberOf Hash
 * @return {?}
 */
function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hashDelete.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes `key` and its value from the hash.
 *
 * Returns `true` if the entry was removed, else `false`.
 *
 * \@memberOf Hash
 * @param {?} key The key of the value to remove.
 * @return {?}
 */
function hashDelete(key) {
    /** @type {?} */
    const result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hashGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to stand-in for `undefined` hash values.
 * @type {?}
 */
const HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$7 = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$5 = objectProto$7.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * Returns the entry value.
 * \@name get
 * \@memberOf Hash
 * @param {?} key
 * @return {?}
 */
function hashGet(key) {
    /** @type {?} */
    const data = this.__data__;
    if (nativeCreate) {
        /** @type {?} */
        const result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$5.call(data, key) ? data[key] : undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hashHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$8 = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$6 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 * Returns `true` if an entry for `key` exists, else `false`.
 * \@memberOf Hash
 * @param {?} key key The key of the entry to check.
 * @return {?}
 */
function hashHas(key) {
    /** @type {?} */
    const data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hashSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to stand-in for `undefined` hash values.
 * @type {?}
 */
const HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 * Returns the hash instance.
 * \@memberOf Hash
 * @param {?} key The key of the value to set.
 * @param {?} value The value to set.
 * @return {?}
 */
function hashSet(key, value) {
    /** @type {?} */
    const data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Hash.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a hash _object.
 *
 * constructor
 * @param {?=} entries The key-value pairs to cache.
 * @return {?}
 */
function Hash(entries) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        /** @type {?} */
        const entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapCacheClear.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes all key-value entries from the map.
 *
 *
 * @return {?}
 */
function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        hash: new Hash(),
        map: new (Map || ListCache)(),
        string: new Hash(),
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isKeyable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is suitable for use as unique _object key.
 *
 * @param {?} value The value to check.
 * Returns `true` if `value` is suitable, else `false`.
 * @return {?}
 */
function isKeyable(value) {
    /** @type {?} */
    const type = typeof value;
    return type === 'string' || type === 'number' || type === 'symbol' || type === 'boolean'
        ? value !== '__proto__'
        : value === null;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getMapData.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the data for `map`.
 *
 * @param {?} map The map to query.
 * @param {?} key The reference key.
 * Returns the map data.
 * @return {?}
 */
function getMapData(map, key) {
    /** @type {?} */
    const data = map.__data__;
    return isKeyable(key) ? data[typeof key === 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapCacheDelete.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Removes `key` and its value from the map.
 *
 * \@memberOf MapCache
 * @param {?} key The key of the value to remove.
 * Returns `true` if the entry was removed, else `false`.
 * @return {?}
 */
function mapCacheDelete(key) {
    /** @type {?} */
    const result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapCacheGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the map value for `key`.
 *
 * \@memberOf MapCache
 * @param {?} key The key of the value to get.
 * Returns the entry value.
 * @return {?}
 */
function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapCacheHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if a map value for `key` exists.
 *
 * \@memberOf MapCache
 * @param {?} key The key of the entry to check.
 * Returns `true` if an entry for `key` exists, else `false`.
 * @return {?}
 */
function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapCacheSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets the map `key` to `value`.
 *
 * \@memberOf MapCache
 * @param {?} key The key of the value to set.
 * @param {?} value The value to set.
 * Returns the map cache instance.
 * @return {?}
 */
function mapCacheSet(key, value) {
    /** @type {?} */
    const data = getMapData(this, key);
    /** @type {?} */
    const size = data.size;
    data.set(key, value);
    this.size += data.size === size ? 0 : 1;
    return this;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_MapCache.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a map cache _object to store key-value pairs.
 *
 * constructor
 * @param {?=} entries The key-value pairs to cache.
 * @return {?}
 */
function MapCache(entries) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        /** @type {?} */
        const entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stackSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as the size to enable large _array optimizations.
 * @type {?}
 */
const LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @param {?} key The key of the value to set.
 * @param {?} value The value to set.
 * Returns the stack cache instance.
 * @return {?}
 */
function stackSet(key, value) {
    /** @type {?} */
    let data = this.__data__;
    if (data instanceof ListCache) {
        /** @type {?} */
        const pairs = ((/** @type {?} */ (data))).__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++((/** @type {?} */ (data))).size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Stack.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a stack cache _object to store key-value pairs.
 *
 * @param {?=} entries The key-value pairs to cache.
 * @return {?}
 */
function Stack(entries) {
    /** @type {?} */
    const data = (this.__data__ = new ListCache(entries));
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_setCacheAdd.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to stand-in for `undefined` hash values.
 * @type {?}
 */
const HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/**
 * Adds `value` to the _array cache.
 *
 * @param {?} value The value to cache.
 * Returns the cache instance.
 * @return {?}
 */
function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED$2);
    return this;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_setCacheHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is in the _array cache.
 *
 * @param {?} value The value to search for.
 * Returns `true` if `value` is found, else `false`.
 * @return {?}
 */
function setCacheHas(value) {
    return this.__data__.has(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_SetCache.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * Creates an _array cache _object to store unique values.
 *
 * @param {?=} values The values to cache.
 * @return {?}
 */
function SetCache(values) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arraySome.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @param {?} array The _array to iterate over.
 * @param {?} predicate The function invoked per iteration.
 * Returns `true` if any element passes the _predicate check,
 *  else `false`.
 * @return {?}
 */
function arraySome(array, predicate) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    while (++index < length) {
        if (predicate(array[index], index, array)) {
            return true;
        }
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_cacheHas.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @param {?} cache The cache to query.
 * @param {?} key The key of the entry to check.
 * Returns `true` if an entry for `key` exists, else `false`.
 * @return {?}
 */
function cacheHas(cache, key) {
    return cache.has(key);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_equalArrays.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG = 1;
/** @type {?} */
const COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @param {?} array The _array to compare.
 * @param {?} other The other _array to compare.
 * @param {?} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {?} customizer The function to customize comparisons.
 * @param {?} equalFunc The function to determine equivalents of values.
 * @param {?} stack Tracks traversed `_array` and `other` objects.
 * Returns `true` if the arrays are equivalent, else `false`.
 * @return {?}
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    // tslint:disable-next-line
    /** @type {?} */
    const isPartial = bitmask & COMPARE_PARTIAL_FLAG;
    /** @type {?} */
    const arrLength = array.length;
    /** @type {?} */
    const othLength = other.length;
    if (arrLength !== othLength && !(isPartial && othLength > arrLength)) {
        return false;
    }
    // Assume cyclic values are equal.
    /** @type {?} */
    const stacked = stack.get(array);
    if (stacked && stack.get(other)) {
        return stacked === other;
    }
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    let result = true;
    /** @type {?} */
    let 
    // tslint:disable-next-line
    seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while (++index < arrLength) {
        /** @type {?} */
        const arrValue = array[index];
        /** @type {?} */
        const othValue = other[index];
        /** @type {?} */
        let compared;
        if (customizer) {
            compared = isPartial
                ? customizer(othValue, arrValue, index, other, array, stack)
                : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
            if (compared) {
                continue;
            }
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, (/**
             * @param {?} _othValue
             * @param {?} othIndex
             * @return {?}
             */
            function (_othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === _othValue || equalFunc(arrValue, _othValue, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                }
            }))) {
                result = false;
                break;
            }
        }
        else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Symbol.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const Symbol = root.Symbol;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_Uint8Array.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const Uint8Array = root.Uint8Array;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_mapToArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `map` to its key-value pairs.
 *
 * @param {?} map The map to convert.
 * Returns the key-value pairs.
 * @return {?}
 */
function mapToArray(map) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const result = Array(map.size);
    map.forEach((/**
     * @param {?} value
     * @param {?} key
     * @return {?}
     */
    function (value, key) {
        result[++index] = [key, value];
    }));
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_setToArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `set` to an _array of its values.
 *
 * @param {?} set The set to convert.
 * Returns the values.
 * @return {?}
 */
function setToArray(set) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const result = Array(set.size);
    set.forEach((/**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        result[++index] = value;
    }));
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_equalByTag.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG$1 = 1;
/** @type {?} */
const COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * `Object#toString` result references.
 * @type {?}
 */
const boolTag$2 = '[object Boolean]';
/** @type {?} */
const dateTag$2 = '[object Date]';
/** @type {?} */
const errorTag$1 = '[object Error]';
/** @type {?} */
const mapTag$3 = '[object Map]';
/** @type {?} */
const numberTag$2 = '[object Number]';
/** @type {?} */
const regexpTag$1 = '[object RegExp]';
/** @type {?} */
const setTag$3 = '[object Set]';
/** @type {?} */
const stringTag$2 = '[object String]';
/** @type {?} */
const symbolTag = '[object Symbol]';
/** @type {?} */
const arrayBufferTag$1 = '[object ArrayBuffer]';
/** @type {?} */
const dataViewTag$2 = '[object DataView]';
/**
 * Used to convert symbols to primitives and strings.
 * @type {?}
 */
const symbolProto = Symbol ? Symbol.prototype : undefined;
/** @type {?} */
const symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @param {?} object The _object to compare.
 * @param {?} other The other _object to compare.
 * @param {?} tag The `toStringTag` of the objects to compare.
 * @param {?} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {?} customizer The function to customize comparisons.
 * @param {?} equalFunc The function to determine equivalents of values.
 * @param {?} stack Tracks traversed `_object` and `other` objects.
 * Returns `true` if the objects are equivalent, else `false`.
 * @return {?}
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    /** @type {?} */
    let convert;
    // tslint:disable:no-switch-case-fall-through
    switch (tag) {
        case dataViewTag$2:
            if (object.byteLength !== other.byteLength || object.byteOffset !== other.byteOffset) {
                return false;
            }
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag$1:
            if (object.byteLength !== other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
            }
            return true;
        case boolTag$2:
        case dateTag$2:
        case numberTag$2:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag$1:
            return object.name === other.name && object.message === other.message;
        case regexpTag$1:
        case stringTag$2:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object === other + '';
        case mapTag$3:
            convert = mapToArray;
        case setTag$3:
            // tslint:disable-next-line:no-bitwise
            /** @type {?} */
            const isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
            convert = convert || (convert = setToArray);
            if (object.size !== other.size && !isPartial) {
                return false;
            }
            // Assume cyclic values are equal.
            /** @type {?} */
            const stacked = stack.get(object);
            if (stacked) {
                return stacked === other;
            }
            // tslint:disable-next-line:no-bitwise
            bitmask |= COMPARE_UNORDERED_FLAG$1;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            /** @type {?} */
            const result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) {
                return symbolValueOf.call(object) === symbolValueOf.call(other);
            }
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayPush.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Appends the elements of `values` to `_array`.
 *
 * @param {?} array The _array to modify.
 * @param {?} values The values to append.
 * Returns `_array`.
 * @return {?}
 */
function arrayPush(array, values) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = values.length;
    /** @type {?} */
    const offset = array.length;
    while (++index < length) {
        array[offset + index] = values[index];
    }
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseGetAllKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `_object`.
 *
 * @param {?} object The _object to query.
 * @param {?} keysFunc The function to get the keys of `_object`.
 * @param {?} symbolsFunc The function to get the symbols of `_object`.
 * Returns the _array of property names and symbols.
 * @return {?}
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    /** @type {?} */
    const result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayFilter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @param {?} array _array to iterate over.
 * @param {?} predicate The function invoked per iteration.
 * Returns the new filtered _array.
 * @return {?}
 */
function arrayFilter(array, predicate) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    /** @type {?} */
    let resIndex = 0;
    /** @type {?} */
    const result = [];
    while (++index < length) {
        /** @type {?} */
        const value = array[index];
        if (predicate(value, index, array)) {
            result[resIndex++] = value;
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/stubArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method returns a new empty _array.
 *
 * Returns the new empty _array.
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 * @return {?}
 */
function stubArray() {
    return [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getSymbols.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$9 = Object.prototype;
/**
 * Built-in value references.
 * @type {?}
 */
const propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an _array of the own enumerable symbols of `_object`.
 *
 * \@param _object The _object to query.
 * Returns the _array of symbols.
 * @type {?}
 */
const getSymbols = !nativeGetSymbols
    ? stubArray
    : (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        if (object == null) {
            return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), (/**
         * @param {?} symbol
         * @return {?}
         */
        function (symbol) {
            return propertyIsEnumerable$1.call(object, symbol);
        }));
    });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseTimes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max _array length checks.
 *
 * @param {?} n The _number of times to invoke `iteratee`.
 * @param {?} iteratee The function invoked per iteration.
 * Returns the _array of results.
 * @return {?}
 */
function baseTimes(n, iteratee) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const result = Array(n);
    while (++index < n) {
        result[index] = iteratee(index);
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isIndex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const MAX_SAFE_INTEGER$1 = 9007199254740991;
/**
 * Used to detect unsigned integer values.
 * @type {?}
 */
const reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid _array-like index.
 *
 * @param {?} value The value to check.
 * @param {?=} length [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * Returns `true` if `value` is a valid index, else `false`.
 * @return {?}
 */
function isIndex(value, length) {
    /** @type {?} */
    const type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return (!!length &&
        (type === 'number' || (type !== 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 === 0 && value < length));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayLikeKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$a = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$7 = objectProto$a.hasOwnProperty;
/**
 * Creates an _array of the enumerable property names of the _array-like `value`.
 *
 * @param {?} value The value to query.
 * @param {?=} inherited Specify returning inherited property names.
 * Returns the _array of property names.
 * @return {?}
 */
function arrayLikeKeys(value, inherited) {
    /** @type {?} */
    const isArr = isArray(value);
    /** @type {?} */
    const isArg = !isArr && isArguments(value);
    /** @type {?} */
    const isBuff = !isArr && !isArg && isBuffer(value);
    /** @type {?} */
    const isType = !isArr && !isArg && !isBuff && isTypedArray(value);
    /** @type {?} */
    const skipIndexes = isArr || isArg || isBuff || isType;
    /** @type {?} */
    const result = skipIndexes ? baseTimes(value.length, String) : [];
    /** @type {?} */
    const length = result.length;
    for (const key in value) {
        if ((inherited || hasOwnProperty$7.call(value, key)) &&
            !(skipIndexes &&
                // Safari 9 has enumerable `arguments.length` in strict mode.
                (key === 'length' ||
                    // Node 0.10 has enumerable non-index properties on buffers.
                    (isBuff && (key === 'offset' || key === 'parent')) ||
                    // Phanto 2 has enumerable non-index properties on typed arrays.
                    (isType && (key === 'buffer' || key === 'byteLength' || key === 'byteOffset')) ||
                    // Skip index properties.
                    isIndex(key, length)))) {
            result.push(key);
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/keys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an _array of the own enumerable property names of `_object`.
 *
 * **Note:** Non-_object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @param {?} object The _object to query.
 * Returns the _array of property names.
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 * @return {?}
 */
function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getAllKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an _array of own enumerable property names and symbols of `_object`.
 *
 * @param {?} object The _object to query.
 * Returns the _array of property names and symbols.
 * @return {?}
 */
function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_equalObjects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG$2 = 1;
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$b = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$8 = objectProto$b.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @param {?} object The _object to compare.
 * @param {?} other The other _object to compare.
 * @param {?} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {?} customizer The function to customize comparisons.
 * @param {?} equalFunc The function to determine equivalents of values.
 * @param {?} stack Tracks traversed `_object` and `other` objects.
 * Returns `true` if the objects are equivalent, else `false`.
 * @return {?}
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    // tslint:disable-next-line:no-bitwise
    /** @type {?} */
    const isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
    /** @type {?} */
    const objProps = getAllKeys(object);
    /** @type {?} */
    const objLength = objProps.length;
    /** @type {?} */
    const othProps = getAllKeys(other);
    /** @type {?} */
    const othLength = othProps.length;
    if (objLength !== othLength && !isPartial) {
        return false;
    }
    /** @type {?} */
    let index = objLength;
    while (index--) {
        /** @type {?} */
        const key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
            return false;
        }
    }
    // Assume cyclic values are equal.
    /** @type {?} */
    const stacked = stack.get(object);
    if (stacked && stack.get(other)) {
        return stacked === other;
    }
    /** @type {?} */
    let result = true;
    stack.set(object, other);
    stack.set(other, object);
    /** @type {?} */
    let skipCtor = isPartial;
    while (++index < objLength) {
        /** @type {?} */
        const key = objProps[index];
        /** @type {?} */
        const objValue = object[key];
        /** @type {?} */
        const othValue = other[key];
        /** @type {?} */
        let compared;
        if (customizer) {
            compared = isPartial
                ? customizer(othValue, objValue, key, other, object, stack)
                : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
            ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack)
            : compared)) {
            result = false;
            break;
        }
        skipCtor = skipCtor || (skipCtor = key === 'constructor');
    }
    if (result && !skipCtor) {
        /** @type {?} */
        const objCtor = object.constructor;
        /** @type {?} */
        const othCtor = other.constructor;
        // Non `Object` _object instances with different constructors are not equal.
        if (objCtor !== othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor === 'function' &&
                objCtor instanceof objCtor &&
                typeof othCtor === 'function' &&
                othCtor instanceof othCtor)) {
            result = false;
        }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsEqualDeep.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG$3 = 1;
/**
 * `Object#toString` result references.
 * @type {?}
 */
const argsTag$2 = '[object Arguments]';
/** @type {?} */
const arrayTag$1 = '[object Array]';
/** @type {?} */
const objectTag$2 = '[object Object]';
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$c = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$9 = objectProto$c.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @param {?} object The _object to compare.
 * @param {?} other The other _object to compare.
 * @param {?} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {?} customizer The function to customize comparisons.
 * @param {?} equalFunc The function to determine equivalents of values.
 * @param {?} stack Tracks traversed `_object` and `other` objects.
 * Returns `true` if the objects are equivalent, else `false`.
 * @return {?}
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    /** @type {?} */
    let objIsArr = isArray(object);
    /** @type {?} */
    const othIsArr = isArray(other);
    /** @type {?} */
    let objTag = objIsArr ? arrayTag$1 : getTag(object);
    /** @type {?} */
    let othTag = othIsArr ? arrayTag$1 : getTag(other);
    objTag = objTag === argsTag$2 ? objectTag$2 : objTag;
    othTag = othTag === argsTag$2 ? objectTag$2 : othTag;
    /** @type {?} */
    let objIsObj = objTag === objectTag$2;
    /** @type {?} */
    const othIsObj = othTag === objectTag$2;
    /** @type {?} */
    const isSameTag = objTag === othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
            return false;
        }
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack = stack || (stack = new Stack());
        return objIsArr || isTypedArray(object)
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    // tslint:disable-next-line:no-bitwise
    if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
        /** @type {?} */
        const objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__');
        /** @type {?} */
        const othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            /** @type {?} */
            const objUnwrapped = objIsWrapped ? object.value() : object;
            /** @type {?} */
            const othUnwrapped = othIsWrapped ? other.value() : other;
            stack = stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) {
        return false;
    }
    stack = stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsEqual.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @param {?} value The value to compare.
 * @param {?} other The other value to compare.
 * @param {?=} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {?=} customizer The function to customize comparisons.
 * @param {?=} stack Tracks traversed `value` and `other` objects.
 * Returns `true` if the values are equivalent, else `false`.
 * @return {?}
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
        return true;
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isEqual.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, _array buffers, booleans,
 * _date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @param {?} value The value to compare.
 * @param {?} other The other value to compare.
 * Returns `true` if the values are equivalent, else `false`.
 *
 * var _object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(_object, other);
 * // => true
 *
 * _object === other;
 * // => false
 * @return {?}
 */
function isEqual(value, other) {
    return baseIsEqual(value, other);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseFindIndex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @param {?} array The _array to inspect.
 * @param {?} predicate The function invoked per iteration.
 * @param {?} fromIndex The index to search from.
 * @param {?=} fromRight Specify iterating from right to left.
 * @return {?}
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
    /** @type {?} */
    const length = array.length;
    /** @type {?} */
    let index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
            return index;
        }
    }
    return -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsNaN.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.isNaN` without support for _number objects.
 * @param {?} value The value to check.
 * @return {?}
 */
function baseIsNan(value) {
    return value !== value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_strictIndexOf.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * Returns the index of the matched value, else `-1`.
 *
 * @param {?} array The _array to inspect.
 *  value The value to search for.
 * @param {?} value
 * @param {?} fromIndex The index to search from.
 * @return {?}
 */
function strictIndexOf(array, value, fromIndex) {
    /** @type {?} */
    let index = fromIndex - 1;
    /** @type {?} */
    const length = array.length;
    while (++index < length) {
        if (array[index] === value) {
            return index;
        }
    }
    return -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIndexOf.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * Returns the index of the matched value, else `-1`.
 * @param {?} array The _array to inspect.
 * @param {?} value The value to search for.
 * @param {?} fromIndex The index to search from.
 * @param {?=} rest just to make compiler happy.
 * @return {?}
 */
function baseIndexOf(array, value, fromIndex, rest) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNan, fromIndex);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isSymbol.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const symbolTag$1 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or _object.
 *
 *
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 * @param {?} value
 * @return {?}
 */
function isSymbol(value) {
    return typeof value === 'symbol' || (isObjectLike(value) && baseGetTag(value) === symbolTag$1);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/toNumber.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const NAN = 0 / 0;
/**
 * Used to match leading and trailing whitespace.
 * @type {?}
 */
const reTrim = /^\s+|\s+$/g;
/**
 * Used to detect bad signed hexadecimal _string values.
 * @type {?}
 */
const reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/**
 * Used to detect binary _string values.
 * @type {?}
 */
const reIsBinary = /^0b[01]+$/i;
/**
 * Used to detect octal _string values.
 * @type {?}
 */
const reIsOctal = /^0o[0-7]+$/i;
/**
 * Built-in method references without a dependency on `root`.
 * @type {?}
 */
const freeParseInt = parseInt;
/**
 * Converts `value` to a _number.
 *
 * @param {?} value The value to process.
 * Returns the _number.
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 * @return {?}
 */
function toNumber(value) {
    if (typeof value === 'number') {
        return value;
    }
    if (isSymbol(value)) {
        return NAN;
    }
    if (isObject(value)) {
        /** @type {?} */
        const other = typeof value.valueOf === 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value !== 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    /** @type {?} */
    const isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value)
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : reIsBadHex.test(value)
            ? NAN
            : +value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/toFinite.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const INFINITY = 1 / 0;
/** @type {?} */
const MAX_INTEGER = 1.7976931348623157e308;
/**
 * Converts `value` to a finite _number.
 *
 * @param {?} value The value to convert.
 * Returns the converted _number.
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 * @return {?}
 */
function toFinite(value) {
    if (!value) {
        return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        /** @type {?} */
        const sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/toInteger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * \@example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 * @param {?} value The value to convert.
 * Returns the converted integer.
 * @return {?}
 */
function toInteger(value) {
    /** @type {?} */
    const result = toFinite(value);
    /** @type {?} */
    const remainder = result % 1;
    return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayMap.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 * @param {?} array The _array to iterate over.
 * @param {?} iteratee The function invoked per iteration.
 * @return {?}
 */
function arrayMap(array, iteratee) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    /** @type {?} */
    const result = Array(length);
    while (++index < length) {
        result[index] = iteratee(array[index], index, array);
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseValues.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * _array of `_object` property values corresponding to the property names
 * of `props`.
 *
 * @param {?} object The _object to query.
 * @param {?} props The property names to get values for.
 * Returns the _array of property values.
 * @return {?}
 */
function baseValues(object, props) {
    return arrayMap(props, (/**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return object[key];
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/values.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an _array of the own enumerable _string keyed property values of `_object`.
 *
 * **Note:** Non-_object values are coerced to objects.
 *
 * @param {?} object The _object to query.
 * Returns the _array of property values.
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 * @return {?}
 */
function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/includes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a _string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @param {?} collection The collection to inspect.
 * @param {?} value The value to search for.
 * @param {?=} fromIndex [fromIndex=0] The index to search from.
 * @param {?=} guard [guard] Enables use as an iteratee for methods like `_.reduce`.
 * Returns `true` if `value` is found, else `false`.
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 * @return {?}
 */
function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
    /** @type {?} */
    const length = collection.length;
    if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
    }
    return isString(collection)
        ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1
        : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_collection/getRandomRangeFromArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Choose a range of items from _array, excluding an item.
 * @param {?} arr
 * @param {?} numberItemsToChoose
 * @param {?=} exclude
 * @return {?} any[]
 */
function getRandomRangeFromArray(arr, numberItemsToChoose, exclude) {
    /** @type {?} */
    let chosenCount = 0;
    /** @type {?} */
    const chosenAccepted = [];
    while (chosenCount < numberItemsToChoose) {
        /** @type {?} */
        const rand = getRandomFromArray(arr);
        if (!isEqual(exclude, rand) && !includes(chosenAccepted, rand)) {
            chosenAccepted.push(rand);
            chosenCount++;
        }
    }
    return chosenAccepted;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getPrototype.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isPlainObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `Object#toString` result references.
 * @type {?}
 */
const objectTag$3 = '[object Object]';
/**
 * Used for built-in method references.
 * @type {?}
 */
const funcProto$2 = Function.prototype;
/** @type {?} */
const objectProto$d = Object.prototype;
/**
 * Used to resolve the decompiled source of functions.
 * @type {?}
 */
const funcToString$2 = funcProto$2.toString;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$a = objectProto$d.hasOwnProperty;
/**
 * Used to infer the `Object` constructor.
 * @type {?}
 */
const objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain _object, that is, an _object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * Returns `true` if `value` is a plain _object, else `false`.
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 *
 * @param {?} value
 * @return {?}
 */
function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) !== objectTag$3) {
        return false;
    }
    /** @type {?} */
    const proto = getPrototype(value);
    if (proto === null) {
        return true;
    }
    /** @type {?} */
    const Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor === 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) === objectCtorString;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseToString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const INFINITY$1 = 1 / 0;
/**
 * Used to convert symbols to primitives and strings.
 * @type {?}
 */
const symbolProto$1 = symbol ? symbol['prototype'] : undefined;
/** @type {?} */
const symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 * Returns the _string.
 *
 * @param {?} value The value to process.
 * @return {?}
 */
function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value === 'string') {
        return value;
    }
    if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    /** @type {?} */
    const result = value + '';
    return result === '0' && 1 / value === -INFINITY$1 ? '-0' : result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseSlice.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 * Returns the slice of `_array`.
 *
 * @param {?} array The _array to slice.
 * @param {?} start [start=0] The start position.
 * @param {?} end [end=_array.length] The end position.
 * @return {?}
 */
function baseSlice(array, start, end) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    let length = array.length;
    if (start < 0) {
        start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    // tslint:disable-next-line
    length = start > end ? 0 : (end - start) >>> 0;
    // tslint:disable-next-line
    start >>>= 0;
    /** @type {?} */
    const result = Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_castSlice.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Casts `_array` to a slice if it's needed.
 *  Returns the cast slice.
 *
 * @param {?} array The _array to inspect.
 * @param {?} start The start position.
 * @param {?} end [end=_array.length] The end position.
 * @return {?}
 */
function castSlice(array, start, end) {
    /** @type {?} */
    const length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_charsEndIndex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last _string symbol
 * that is not found in the character symbols.
 * Returns the index of the last unmatched _string symbol.
 *
 * @param {?} strSymbols The _string symbols to inspect.
 * @param {?} chrSymbols The character symbols to find.
 * @return {?}
 */
function charsEndIndex(strSymbols, chrSymbols) {
    /** @type {?} */
    let index = strSymbols.length;
    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
    return index;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_charsStartIndex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first _string symbol
 * that is not found in the character symbols.
 *
 * Returns the index of the first unmatched _string symbol.
 *
 * @param {?} strSymbols The _string symbols to inspect.
 * @param {?} chrSymbols The character symbols to find.
 * @return {?}
 */
function charsStartIndex(strSymbols, chrSymbols) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = strSymbols.length;
    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) { }
    return index;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_asciiToArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts an ASCII `_string` to an _array.
 * @param {?} string The _string to convert.
 * @return {?}
 */
function asciiToArray(string) {
    return string.split('');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hasUnicode.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose unicode character classes.
 * @type {?}
 */
const rsAstralRange = '\\ud800-\\udfff';
/** @type {?} */
const rsComboMarksRange = '\\u0300-\\u036f';
/** @type {?} */
const reComboHalfMarksRange = '\\ufe20-\\ufe2f';
/** @type {?} */
const rsComboSymbolsRange = '\\u20d0-\\u20ff';
/** @type {?} */
const rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
/** @type {?} */
const rsVarRange = '\\ufe0e\\ufe0f';
/**
 * Used to compose unicode capture groups.
 * @type {?}
 */
const rsZWJ = '\\u200d';
/**
 * Used to detect strings with
 * http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/
 * @type {?}
 */
const reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `_string` contains Unicode symbols.
 *
 * Returns `true` if a symbol is found, else `false`.
 *
 * @param {?} string The _string to inspect.
 * @return {?}
 */
function hasUnicode(string) {
    return reHasUnicode.test(string);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_unicodeToArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose unicode character classes.
 * @type {?}
 */
const rsAstralRange$1 = '\\ud800-\\udfff';
/** @type {?} */
const rsComboMarksRange$1 = '\\u0300-\\u036f';
/** @type {?} */
const reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
/** @type {?} */
const rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
/** @type {?} */
const rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
/** @type {?} */
const rsVarRange$1 = '\\ufe0e\\ufe0f';
/**
 * Used to compose unicode capture groups.
 * @type {?}
 */
const rsAstral = '[' + rsAstralRange$1 + ']';
/** @type {?} */
const rsCombo = '[' + rsComboRange$1 + ']';
/** @type {?} */
const rsFitz = '\\ud83c[\\udffb-\\udfff]';
/** @type {?} */
const rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
/** @type {?} */
const rsNonAstral = '[^' + rsAstralRange$1 + ']';
/** @type {?} */
const rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
/** @type {?} */
const rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
/** @type {?} */
const rsZWJ$1 = '\\u200d';
/**
 * Used to compose unicode regexes.
 * @type {?}
 */
const reOptMod = rsModifier + '?';
/** @type {?} */
const rsOptVar = '[' + rsVarRange$1 + ']?';
/** @type {?} */
const rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
/** @type {?} */
const rsSeq = rsOptVar + reOptMod + rsOptJoin;
/** @type {?} */
const rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/**
 * Used to match [_string symbols](https://mathiasbynens.be/notes/javascript-unicode).
 * @type {?}
 */
const reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `_string` to an _array.
 *
 * Returns the converted _array.
 *
 * @param {?} string The _string to convert.
 * @return {?}
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stringToArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `_string` to an _array.
 *
 * Returns the converted _array.
 *
 * @param {?} string The _string to convert.
 * @return {?}
 */
function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/toString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `value` to a _string. An empty _string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 *
 * \@memberOf _
 * \@since 4.0.0
 * \@category Lang
 * @param {?} value The value to convert.
 *
 * Returns the converted _string.
 *
 * _.toString();
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 * @param {?=} defaultValue
 * @return {?}
 */
// export function toString(value: any): _string {
//   return value == null ? '' : baseToString(value) === '[object Object]' ? value.toString() : '';
// }
// import { hasValue } from '@uiux/cdk/value';
// import { isDate } from './isDate';
//
function toString(value, defaultValue) {
    if (isDate(value)) {
        return value.toJSON();
    }
    else if (value && hasValue(value) && value.toString) {
        return value.toString();
    }
    else {
        if (defaultValue) {
            return defaultValue;
        }
        else {
            return '';
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/trim.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const reTrim$1 = /^\s+|\s+$/g;
/**
 * Removes leading and trailing whitespace or specified characters from `_string`.
 *
 *
 * @param {?} string [_string=''] The _string to trim.
 * @param {?=} chars [chars=whitespace] The characters to trim.
 * @param {?=} guard Enables use as an iteratee for methods like `_.map`.
 * Returns the trimmed _string.
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 * @return {?}
 */
function trim(string, chars, guard) {
    string = toString(string);
    if (string && (guard || chars === undefined)) {
        return string.replace(reTrim$1, '');
    }
    if (!string || !(chars = baseToString(chars))) {
        return string;
    }
    /** @type {?} */
    const strSymbols = stringToArray(string);
    /** @type {?} */
    const chrSymbols = stringToArray(chars);
    /** @type {?} */
    const start = charsStartIndex(strSymbols, chrSymbols);
    /** @type {?} */
    const end = charsEndIndex(strSymbols, chrSymbols) + 1;
    return castSlice(strSymbols, start, end).join('');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isTruthy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isTruthy(value) {
    if (hasValue(value)) {
        // Testing for Truthy
        if (isString(value)) {
            return value === '0' ? Boolean(parseInt(value, 10)) : !isEmpty(trim(value));
        }
        else if (isNumber(value)) {
            return Boolean(value); // true for all numbers
        }
        else if (isBoolean(value)) {
            // Testing for value, not truthy
            return value;
        }
        else if (isFunction(value)) {
            return true;
        }
        else {
            return !isEmpty(value);
        }
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/keysAreTruthy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @param {?=} keys
 * @return {?}
 */
function keysAreTruthy(value, keys) {
    if (isPlainObject(value)) {
        if (!isEmpty(value)) {
            if (keys && keys.length) {
                /** @type {?} */
                let allPropsHaveValue = true;
                /** @type {?} */
                const length = keys.length;
                for (let i = 0; i < length; i++) {
                    /** @type {?} */
                    const _key = keys[i];
                    /** @type {?} */
                    const _value = value[_key];
                    allPropsHaveValue = isTruthy(_value);
                    if (!allPropsHaveValue) {
                        break;
                    }
                }
                return allPropsHaveValue;
            }
            else {
                // is plain _object but not keys provided
                // and _object is not empty
                return true;
            }
        }
        else {
            // plain _object is empty
            return false;
        }
    }
    else {
        return !isEmpty(value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_collection/keysAreTruthyInCollection.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Given a collection of objects, test if provided keys are truthy in each object.
 * Returns true if each provided key in each object of collection is truthy.
 * @template T
 * @param {?} collection of objects
 * @param {?} keys array of key strings
 * @return {?}
 */
function keysAreTruthyInCollection(collection, keys) {
    /** @type {?} */
    const _keys = isArray(keys) ? keys : [keys];
    return collection.reduce((/**
     * @param {?} isTruthy
     * @param {?} i
     * @return {?}
     */
    (isTruthy, i) => {
        if (isTruthy === true) {
            return keysAreTruthy(i, _keys);
        }
        return isTruthy;
    }), true);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isDefined.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/**
 * @param {?} value
 * @return {?}
 */
function isDefined(value) {
    return value !== null && value !== undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/atLeast.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} min
 * @return {?}
 */
function atLeast(min) {
    if (!isDefined(min) || !isNumber(min)) {
        throw new Error('min provided must be a _number');
    }
    return (/**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        if (!isDefined(val) || !isNumber(val)) {
            throw new Error('Value provided must be a _number');
        }
        return val > min ? val : min;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/clone.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { fromJS } from 'immutable';
/**
 * @param {?} obj
 * @return {?}
 */
function clone(obj) {
    // return cloneDeep(obj);
    if (isPlainObject(obj) && hasValue(obj)) {
        return JSON.parse(JSON.stringify(obj));
        // return fromJS(obj).toJS();
    }
    else {
        return obj;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a function that returns `value`.
 *
 * @param {?} value The value to return from the new function.
 * @return {?} Returns the new constant function.
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
    return (/**
     * @return {?}
     */
    function () {
        return value;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_basePropertyOf.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 * Returns the new accessor function.
 *
 * @param {?} object The _object to query.
 * @return {?}
 */
function basePropertyOf(object) {
    return (/**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return object == null ? undefined : object[key];
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_deburrLetter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to map Latin Unicode letters to basic Latin letters.
 * @type {?}
 */
const deburredLetters = {
    // Latin-1 Supplement block.
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    Ç: 'C',
    ç: 'c',
    Ð: 'D',
    ð: 'd',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    Ñ: 'N',
    ñ: 'n',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ø: 'O',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ü: 'u',
    Ý: 'Y',
    ý: 'y',
    ÿ: 'y',
    Æ: 'Ae',
    æ: 'ae',
    Þ: 'Th',
    þ: 'th',
    ß: 'ss',
    // Latin Extended-A block.
    Ā: 'A',
    Ă: 'A',
    Ą: 'A',
    ā: 'a',
    ă: 'a',
    ą: 'a',
    Ć: 'C',
    Ĉ: 'C',
    Ċ: 'C',
    Č: 'C',
    ć: 'c',
    ĉ: 'c',
    ċ: 'c',
    č: 'c',
    Ď: 'D',
    Đ: 'D',
    ď: 'd',
    đ: 'd',
    Ē: 'E',
    Ĕ: 'E',
    Ė: 'E',
    Ę: 'E',
    Ě: 'E',
    ē: 'e',
    ĕ: 'e',
    ė: 'e',
    ę: 'e',
    ě: 'e',
    Ĝ: 'G',
    Ğ: 'G',
    Ġ: 'G',
    Ģ: 'G',
    ĝ: 'g',
    ğ: 'g',
    ġ: 'g',
    ģ: 'g',
    Ĥ: 'H',
    Ħ: 'H',
    ĥ: 'h',
    ħ: 'h',
    Ĩ: 'I',
    Ī: 'I',
    Ĭ: 'I',
    Į: 'I',
    İ: 'I',
    ĩ: 'i',
    ī: 'i',
    ĭ: 'i',
    į: 'i',
    ı: 'i',
    Ĵ: 'J',
    ĵ: 'j',
    Ķ: 'K',
    ķ: 'k',
    ĸ: 'k',
    Ĺ: 'L',
    Ļ: 'L',
    Ľ: 'L',
    Ŀ: 'L',
    Ł: 'L',
    ĺ: 'l',
    ļ: 'l',
    ľ: 'l',
    ŀ: 'l',
    ł: 'l',
    Ń: 'N',
    Ņ: 'N',
    Ň: 'N',
    Ŋ: 'N',
    ń: 'n',
    ņ: 'n',
    ň: 'n',
    ŋ: 'n',
    Ō: 'O',
    Ŏ: 'O',
    Ő: 'O',
    ō: 'o',
    ŏ: 'o',
    ő: 'o',
    Ŕ: 'R',
    Ŗ: 'R',
    Ř: 'R',
    ŕ: 'r',
    ŗ: 'r',
    ř: 'r',
    Ś: 'S',
    Ŝ: 'S',
    Ş: 'S',
    Š: 'S',
    ś: 's',
    ŝ: 's',
    ş: 's',
    š: 's',
    Ţ: 'T',
    Ť: 'T',
    Ŧ: 'T',
    ţ: 't',
    ť: 't',
    ŧ: 't',
    Ũ: 'U',
    Ū: 'U',
    Ŭ: 'U',
    Ů: 'U',
    Ű: 'U',
    Ų: 'U',
    ũ: 'u',
    ū: 'u',
    ŭ: 'u',
    ů: 'u',
    ű: 'u',
    ų: 'u',
    Ŵ: 'W',
    ŵ: 'w',
    Ŷ: 'Y',
    ŷ: 'y',
    Ÿ: 'Y',
    Ź: 'Z',
    Ż: 'Z',
    Ž: 'Z',
    ź: 'z',
    ż: 'z',
    ž: 'z',
    Ĳ: 'IJ',
    ĳ: 'ij',
    Œ: 'Oe',
    œ: 'oe',
    // tslint:disable-next-line
    ŉ: "'n",
    ſ: 's',
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * Returns the deburred letter Function.
 *
 * \@param string letter The matched letter to deburr.
 * @type {?}
 */
const deburrLetter = basePropertyOf(deburredLetters);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/deburr.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to match Latin Unicode letters (excluding mathematical operators).
 * @type {?}
 */
const reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/**
 * Used to compose unicode character classes.
 * @type {?}
 */
const rsComboMarksRange$2 = '\\u0300-\\u036f';
/** @type {?} */
const reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f';
/** @type {?} */
const rsComboSymbolsRange$2 = '\\u20d0-\\u20ff';
/** @type {?} */
const rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;
/**
 * Used to compose unicode capture groups.
 * @type {?}
 */
const rsCombo$1 = '[' + rsComboRange$2 + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 * @type {?}
 */
const reComboMark = RegExp(rsCombo$1, 'g');
/**
 * Deburrs `_string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * Returns the deburred _string.
 *
 * @param {?} string [_string=''] The _string to deburr.
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 * @return {?}
 */
function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayIncludes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @param {?} array {Array} [_array] The _array to inspect.
 * @param {?} value {*} target The value to search for.
 * @param {?=} fromIndex
 * Returns `true` if `target` is found, else `false`.
 * @return {?}
 */
function arrayIncludes(array, value, fromIndex) {
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayIncludesWith.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @param {?} array {Array} [_array] The _array to inspect.
 * @param {?} value
 * @param {?} comparator {Function} comparator The comparator invoked per element.
 * Returns `true` if `target` is found, else `false`.
 * @return {?}
 */
function arrayIncludesWith(array, value, comparator) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    while (++index < length) {
        if (comparator(value, array[index])) {
            return true;
        }
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseDifference.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as the size to enable large _array optimizations.
 * @type {?}
 */
const LARGE_ARRAY_SIZE$1 = 200;
/**
 * The base implementation of methods like `_.differenceObject` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @param {?} array The _array to inspect.
 * @param {?} values The values to exclude.
 * @param {?=} iteratee
 * @param {?=} comparator
 * @return {?}
 */
function baseDifference(array, values, iteratee, comparator) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    let includes = arrayIncludes;
    /** @type {?} */
    let isCommon = true;
    /** @type {?} */
    const length = array.length;
    /** @type {?} */
    const result = [];
    /** @type {?} */
    const valuesLength = values.length;
    if (!length) {
        return result;
    }
    if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
    }
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    }
    else if (values.length >= LARGE_ARRAY_SIZE$1) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while (++index < length) {
        /** @type {?} */
        let value = array[index];
        /** @type {?} */
        const computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            /** @type {?} */
            let valuesIndex = valuesLength;
            while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                    continue outer;
                }
            }
            result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
            result.push(value);
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isFlattenable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` _object or _array.
 *
 * @param {?} value The value to check.
 * @return {?}
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseFlatten.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @param {?} array The _array to flatten.
 * @param {?} depth The maximum recursion depth.
 * @param {?=} predicate
 * @param {?=} isStrict
 * @param {?=} result
 * @return {?}
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array.length;
    predicate = predicate || (predicate = isFlattenable);
    result = result || (result = []);
    while (++index < length) {
        /** @type {?} */
        const value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) {
                // Recursively flatten arrays (susceptible to call stack limits).
                baseFlatten(value, depth - 1, predicate, isStrict, result);
            }
            else {
                arrayPush(result, value);
            }
        }
        else if (!isStrict) {
            result[result.length] = value;
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/identity.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method returns the first argument it receives.
 *
 * @param {?} value Any value.
 * @return {?} Returns `value`.
 *
 * var _object = { 'a': 1 };
 *
 * console.log(_.identity(_object) === _object);
 * // => true
 */
function identity(value) {
    return value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_apply.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 * @ignore
 * @param {?} func The function to invoke.
 * @param {?} thisArg The `this` binding of `func`.
 * @param {?} args The arguments to invoke `func` with.
 * Returns the result of `func`.
 * @return {?}
 */
function apply(func, thisArg, args) {
    switch (args.length) {
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_overRest.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeMax$1 = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest _array.
 *
 * @param {?} func The function to apply a rest parameter to.
 * @param {?} start
 * @param {?} transform The rest _array transform.
 * Returns the new function.
 * @return {?}
 */
function overRest(func, start, transform) {
    start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
    return (/**
     * @return {?}
     */
    function () {
        /** @type {?} */
        const args = arguments;
        /** @type {?} */
        let index = -1;
        /** @type {?} */
        const length = nativeMax$1(args.length - start, 0);
        /** @type {?} */
        const array = Array(length);
        while (++index < length) {
            array[index] = args[start + index];
        }
        index = -1;
        /** @type {?} */
        const otherArgs = Array(start + 1);
        while (++index < start) {
            otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_defineProperty.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$2 = /**
 * @return {?}
 */
function () {
    try {
        /** @type {?} */
        const func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    }
    catch (e) { }
};
/** @type {?} */
const defineProperty = ((ɵ0$2))();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseSetToString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * \@param func The function to modify.
 * \@param string The `toString` result.
 * Returns `func`.
 * @type {?}
 */
const baseSetToString = !defineProperty
    ? identity
    : (/**
     * @param {?} func
     * @param {?} string
     * @return {?}
     */
    function (func, string) {
        return defineProperty(func, 'toString', {
            configurable: true,
            enumerable: false,
            value: constant(string),
            writable: true,
        });
    });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_shortOut.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to detect hot functions by _number of calls within a span of milliseconds.
 * @type {?}
 */
const HOT_COUNT = 800;
/** @type {?} */
const HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @param {?} func The function to restrict.
 * Returns the new shortable function.
 * @return {?}
 */
function shortOut(func) {
    /** @type {?} */
    let count = 0;
    /** @type {?} */
    let lastCalled = 0;
    return (/**
     * @return {?}
     */
    function () {
        /** @type {?} */
        const stamp = nativeNow();
        /** @type {?} */
        const remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) {
                return arguments[0];
            }
        }
        else {
            count = 0;
        }
        return func.apply(undefined, arguments);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_setToString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets the `toString` method of `func` to return `_string`.
 *
 * \@param func The function to modify.
 * \@param _string The `toString` result.
 * Returns `func`.
 * @type {?}
 */
const setToString = shortOut(baseSetToString);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseRest.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @param {?} func The function to apply a rest parameter to.
 * @param {?=} start [start=func.length-1] The start position of the rest parameter.
 * Returns the new function.
 * @return {?}
 */
function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isArrayLikeObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an _object.
 *
 * @param {?} value The value to check.
 * Returns `true` if `value` is an _array-like _object,
 *  else `false`.
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 * @return {?}
 */
function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/difference.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$3 = /**
 * @param {?} array
 * @param {?} values
 * @return {?}
 */
function (array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
};
/**
 * Creates an _array of `_array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first _array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new _array.
 *
 *
 * \@memberOf _
 * \@since 0.1.0
 * \@category Array
 * \@param _array The _array to inspect.
 * \@param [values] The values to exclude.
 * \@return Returns the new _array of filtered values.
 * @see _.without, _.xor
 * \@example
 *
 * _.differenceObject([2, 1], [2, 3]);
 * // => [1]
 * @type {?}
 */
const difference = baseRest((ɵ0$3));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/last.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the last element of `array`.
 *
 * \@since 0.1.0
 * \@category Array
 * \@example
 *
 * last([1, 2, 3])
 * // => 3
 * @param {?} array array The array to query.
 * @return {?}
 */
function last(array) {
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/differenceBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method is like `difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `pullAllBy`, this method returns a new array.
 *
 * \@since 4.0.0
 * \@category Array
 * \@example
 *
 * differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor)
 * // => [1.2]
 * @param {?} array array The array to inspect.
 * @param {...?} values  The values to exclude.
 * @return {?}
 */
function differenceBy(array, ...values) {
    /** @type {?} */
    let iteratee = last(values);
    if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
    }
    return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), iteratee)
        : [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIsMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG$4 = 1;
/** @type {?} */
const COMPARE_UNORDERED_FLAG$2 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @param {?} object The _object to inspect.
 * @param {?} source The _object of property values to match.
 * @param {?} matchData The property names, values, and compare flags to match.
 * @param {?=} customizer The function to customize comparisons.
 * Returns `true` if `_object` is a match, else `false`.
 * @return {?}
 */
function baseIsMatch(object, source, matchData, customizer) {
    /** @type {?} */
    let index = matchData.length;
    /** @type {?} */
    const length = index;
    /** @type {?} */
    const noCustomizer = !customizer;
    if (object == null) {
        return !length;
    }
    object = Object(object);
    /** @type {?} */
    let data;
    while (index--) {
        data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
        }
    }
    /** @type {?} */
    let key;
    while (++index < length) {
        data = matchData[index];
        key = data[0];
        /** @type {?} */
        const objValue = object[key];
        /** @type {?} */
        const srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) {
                return false;
            }
        }
        else {
            /** @type {?} */
            const stack = new Stack();
            /** @type {?} */
            let result;
            if (customizer) {
                result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, 
                // tslint:disable-next-line:no-bitwise
                COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
                : result)) {
                return false;
            }
        }
    }
    return true;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isStrictComparable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @param {?} value The value to check.
 * @return {?} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
    return value === value && !isObject(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_getMatchData.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the property names, values, and compare flags of `_object`.
 *
 * @param {?} object The _object to query.
 * Returns the match data of `_object`.
 * @return {?}
 */
function getMatchData(object) {
    /** @type {?} */
    const result = keys(object);
    /** @type {?} */
    let length = result.length;
    while (length--) {
        /** @type {?} */
        const key = result[length];
        /** @type {?} */
        const value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_matchesStrictComparable.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @param {?} key The key of the property to get.
 * @param {?} srcValue The value to match.
 * Returns the new spec function.
 * @return {?}
 */
function matchesStrictComparable(key, srcValue) {
    return (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        if (object == null) {
            return false;
        }
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseMatches.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @param {?} source The _object of property values to match.
 * Returns the new spec function.
 * @return {?}
 */
function baseMatches(source) {
    /** @type {?} */
    const matchData = getMatchData(source);
    if (matchData.length === 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        return object === source || baseIsMatch(object, source, matchData);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isKey.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to match property names within property paths.
 * @type {?}
 */
const reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
/** @type {?} */
const reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * Returns `true` if `value` is a property name, else `false`.
 *
 * @param {?} value value The value to check.
 * @param {?=} object [_object] The _object to query keys on.
 * @return {?}
 */
function isKey(value, object) {
    if (isArray(value)) {
        return false;
    }
    /** @type {?} */
    const type = typeof value;
    if (type === 'number' || type === 'symbol' || type === 'boolean' || value == null || isSymbol(value)) {
        return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || (object != null && value in Object(object));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/memoize.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Error message constants.
 * @type {?}
 */
const FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * \@category Function
 * @param {?} func The function to have its output memoized.
 * @param {?} resolver The function to resolve the cache key.
 * @return {?} Returns the new memoized function.
 *
 * var _object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(_object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * _object.a = 2;
 * values(_object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(_object, ['a', 'b']);
 * values(_object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
    if (typeof func !== 'function' || (resolver != null && typeof resolver !== 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    /** @type {?} */
    const memoized = (/**
     * @return {?}
     */
    function () {
        /** @type {?} */
        const args = arguments;
        /** @type {?} */
        const key = resolver ? resolver.apply(this, args) : args[0];
        /** @type {?} */
        const cache = memoized.cache;
        if (cache.has(key)) {
            return cache.get(key);
        }
        /** @type {?} */
        const result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    });
    memoized.cache = new (((/** @type {?} */ (memoize))).Cache || MapCache)();
    return memoized;
}
// Expose `MapCache`.
((/** @type {?} */ (memoize))).Cache = MapCache;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_memoizeCapped.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as the maximum memoize cache size.
 * @type {?}
 */
const MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @param {?} func The function to have its output memoized.
 * Returns the new memoized function.
 * @return {?}
 */
function memoizeCapped(func) {
    /** @type {?} */
    let cache;
    /** @type {?} */
    const result = memoize(func, (/**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
        }
        return key;
    }));
    cache = result.cache;
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_stringToPath.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line
/**
 * Used to match property names within property paths.
 * @type {?}
 */
const rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match backslashes in property paths.
 * @type {?}
 */
const reEscapeChar = /\\(\\)?/g;
const ɵ0$4 = /**
 * @param {?} string
 * @return {?}
 */
function (string) {
    /** @type {?} */
    const result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
    }
    string.replace(rePropName, (/**
     * @param {?} match
     * @param {?} number
     * @param {?} quote
     * @param {?} subString
     * @return {?}
     */
    function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    }));
    return result;
};
/**
 * Converts `_string` to a property path _array.
 *
 *
 * \@param _string The _string to convert.
 * Returns the property path _array.
 * @type {?}
 */
const stringToPath = memoizeCapped((ɵ0$4));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_castPath.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Casts `value` to a path _array if it's not one.
 *
 * @param {?} value The value to inspect.
 * @param {?} object The _object to query keys on.
 * Returns the cast property path _array.
 * @return {?}
 */
function castPath(value, object) {
    if (isArray(value)) {
        return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_toKey.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const INFINITY$2 = 1 / 0;
/**
 * Converts `value` to a _string key if it's not a _string or symbol.
 *
 * @param {?} value The value to inspect.
 * Returns the key.
 * @return {?}
 */
function toKey(value) {
    if (typeof value === 'string' || isSymbol(value)) {
        return value;
    }
    /** @type {?} */
    const result = value + '';
    return result === '0' && 1 / value === -INFINITY$2 ? '-0' : result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @param {?} object The _object to query.
 * @param {?} path The path of the property to get.
 * Returns the resolved value.
 * @return {?}
 */
function baseGet(object, path) {
    path = castPath(path, object);
    /** @type {?} */
    let index = 0;
    /** @type {?} */
    const length = path.length;
    while (object != null && index < length) {
        object = object[toKey(path[index++])];
    }
    return index && index === length ? object : undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/get.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the value at `path` of `_object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @param {?} object The _object to query.
 * @param {?} path of the property to get.
 * @param {?=} defaultValue The value returned for `undefined` resolved values.
 * Returns the resolved value.
 *
 * var _object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(_object, 'a[0].b.c');
 * // => 3
 *
 * _.get(_object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(_object, 'a.b.c', 'default');
 * // => 'default'
 * @return {?}
 */
function get(object, path, defaultValue) {
    /** @type {?} */
    const result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseHasIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @param {?} object [_object] The _object to query.
 * @param {?} key The key to check.
 * Returns `true` if `key` exists, else `false`.
 * @return {?}
 */
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hasPath.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `path` exists on `_object`.
 *
 * @param {?} object The _object to query.
 * @param {?} path The path to check.
 * @param {?} hasFunc The function to check properties.
 * Returns `true` if `path` exists, else `false`.
 * @return {?}
 */
function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    let length = path.length;
    /** @type {?} */
    let result = false;
    /** @type {?} */
    let key;
    while (++index < length) {
        key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
            break;
        }
        object = object[key];
    }
    if (result || ++index !== length) {
        return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `path` is a direct or inherited property of `_object`.
 *
 * @param {?} object The _object to query.
 * @param {?} path The path to check.
 * Returns `true` if `path` exists, else `false`.
 *
 * var _object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(_object, 'a');
 * // => true
 *
 * _.hasIn(_object, 'a.b');
 * // => true
 *
 * _.hasIn(_object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(_object, 'b');
 * // => false
 * @return {?}
 */
function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseMatchesProperty.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to compose bitmasks for value comparisons.
 * @type {?}
 */
const COMPARE_PARTIAL_FLAG$5 = 1;
/** @type {?} */
const COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @param {?} path {string} path The path of the property to get.
 * @param {?} srcValue {*} srcValue The value to match.
 * Returns the new spec function.
 * @return {?}
 */
function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
    }
    return (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        /** @type {?} */
        const objValue = get(object, path);
        return objValue === undefined && objValue === srcValue
            ? hasIn(object, path)
            : // tslint:disable-next-line
                baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseProperty.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @param {?} key The key of the property to get.
 * Returns the new accessor function.
 * @return {?}
 */
function baseProperty(key) {
    return (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        return object == null ? undefined : object[key];
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_basePropertyDeep.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @param {?} path {Array|string} path The path of the property to get.
 * Returns the new accessor function.
 * @return {?}
 */
function basePropertyDeep(path) {
    return (/**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        return baseGet(object, path);
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/property.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a function that returns the value at `path` of a given _object.
 *
 * \@example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 * @param {?} path {Array|string} path The path of the property to get.
 * Returns the new accessor function.
 * @return {?}
 */
function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIteratee.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.iteratee`.
 *
 * @param {...?} value {*} [value=_.identity] The value to convert to an iteratee.
 * Returns the iteratee.
 * @return {?}
 */
function baseIteratee(...value) {
    value = value && value.length === 1 ? value.pop() : value;
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value === 'function') {
        return value;
    }
    if (value == null) {
        return identity;
    }
    if (typeof value === 'object') {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/findIndex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeMax$2 = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `_predicate` returns truthy for instead of the element itself.
 *
 * \@example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 * @param {?} array The _array to inspect.
 * @param {?} predicate [_predicate=_.identity] The function invoked per iteration.
 * @param {?=} fromIndex [fromIndex=0] The index to search from.
 * @return {?}
 */
function findIndex(array, predicate, fromIndex = null) {
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    /** @type {?} */
    let index = fromIndex === null ? 0 : toInteger(fromIndex);
    if (index < 0) {
        index = nativeMax$2(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_createBaseFor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @param {?=} fromRight Specify iterating from right to left.
 * @return {?} Returns the new base function.
 */
function createBaseFor(fromRight) {
    return (/**
     * @param {?} object
     * @param {?} iteratee
     * @param {?} keysFunc
     * @return {?}
     */
    function (object, iteratee, keysFunc) {
        /** @type {?} */
        let index = -1;
        /** @type {?} */
        const iterable = Object(object);
        /** @type {?} */
        const props = keysFunc(object);
        /** @type {?} */
        let length = props.length;
        while (length--) {
            /** @type {?} */
            const key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
                break;
            }
        }
        return object;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseFor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `baseForOwn` which iterates over `_object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * \@param _object The _object to iterate over.
 * \@param iteratee The function invoked per iteration.
 * \@param keysFunc The function to get the keys of `_object`.
 * Returns `_object`.
 * @type {?}
 */
let baseFor = createBaseFor();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_castFunction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @param {?} value The value to inspect.
 * Returns cast function.
 * @return {?}
 */
function castFunction(value) {
    return typeof value === 'function' ? value : identity;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_nativeKeysIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @param {?} object The _object to query.
 * Returns the _array of property names.
 * @return {?}
 */
function nativeKeysIn(object) {
    /** @type {?} */
    const result = [];
    if (object != null) {
        for (const key in Object(object)) {
            if (object.hasOwnProperty(key)) {
                result.push(key);
            }
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseKeysIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$e = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$b = objectProto$e.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @param {?} object The _object to query.
 * Returns the _array of property names.
 * @return {?}
 */
function baseKeysIn(object) {
    if (!isObject(object)) {
        return nativeKeysIn(object);
    }
    /** @type {?} */
    const isProto = isPrototype(object);
    /** @type {?} */
    const result = [];
    for (const key in object) {
        if (object.hasOwnProperty(key)) {
            if (!(key === 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
                result.push(key);
            }
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/keysIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an _array of the own and inherited enumerable property names of `_object`.
 *
 * **Note:** Non-_object values are coerced to objects.
 *
 * \@example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 * @param {?} object The _object to query.
 * @return {?} Returns the _array of property names.
 */
function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/forIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Iterates over own and inherited enumerable _string keyed properties of an
 * _object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, _object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @see _.forInRight
 * \@example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 * @param {?} object The _object to iterate over.
 * @param {?} iteratee [iteratee=_.identity] The function invoked per iteration.
 * Returns `_object`.
 * @return {?}
 */
function forIn(object, iteratee) {
    return object == null ? object : baseFor(object, castFunction(iteratee), keysIn);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/getIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the value at `path` of `_object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @param {?} object The _object to query.
 * @param {?} path of the property to get.
 * @param {?=} defaultValue The value returned for `undefined` resolved values.
 * Returns the resolved value.
 *
 * var _object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(_object, 'a[0].b.c');
 * // => 3
 *
 * _.get(_object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(_object, 'a.b.c', 'default');
 * // => 'default'
 * @return {?}
 */
function getIn(object, path, defaultValue) {
    /** @type {?} */
    const result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueEqual.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} targetValue
 * @param {?} srcValue
 * @return {?}
 */
function hasValueEqual(targetValue, srcValue) {
    if (hasValue(srcValue)) {
        return targetValue === srcValue;
    }
    else {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueEqualIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} targetValue
 * @param {?} targetKeys
 * @param {?} srcValue
 * @param {?} srcKeys
 * @return {?}
 */
function hasValueEqualIn(targetValue, targetKeys, srcValue, srcKeys) {
    return hasValueEqual(getIn(targetValue, targetKeys), getIn(srcValue, srcKeys));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueEqualTo.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} targetValue
 * @param {?} targetKeys
 * @param {?} value
 * @return {?}
 */
function hasValueEqualTo(targetValue, targetKeys, value) {
    return hasValueEqual(getIn(targetValue, targetKeys), value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns whether or not the nested property is defined. Keys may be an
 * _array, or a dot-delimited _string of properties.
 *
 * @param {?} object
 * @param {?} keys
 * boolean
 * @return {?}
 */
function hasValueIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return hasValue(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueNotEqual.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} targetValue
 * @param {?} srcValue
 * @return {?}
 */
function hasValueNotEqual(targetValue, srcValue) {
    if (hasValue(srcValue)) {
        return targetValue !== srcValue;
    }
    else {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/hasValueNotEqualIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} targetValue
 * @param {?} targetKeys
 * @param {?} srcValue
 * @param {?} srcKeys
 * @return {?}
 */
function hasValueNotEqualIn(targetValue, targetKeys, srcValue, srcKeys) {
    return hasValueNotEqual(getIn(targetValue, targetKeys), getIn(srcValue, srcKeys));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Performs a partial deep comparison between `_object` and `source` to
 * determine if `_object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty _array and empty _object `source`
 * values against any _array or _object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @param {?} object The _object to inspect.
 * @param {?} source The _object of property values to match.
 * Returns `true` if `_object` is a match, else `false`.
 *
 * var _object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(_object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(_object, { 'b': 1 });
 * // => false
 * @return {?}
 */
function isMatch(object, source) {
    return object === source || baseIsMatch(object, source, getMatchData(source));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isNull.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is `null`.
 *
 * Returns `true` if `value` is `null`, else `false`.
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 *
 * @param {?} value Value to check
 * @return {?}
 */
function isNull(value) {
    return value === null;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isUndefined.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if `value` is `undefined`.
 *
 * Returns `true` if `value` is `undefined`, else `false`.
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 *
 * @param {?} value Value to check.
 * @return {?}
 */
function isUndefined(value) {
    return value === undefined;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isScalar.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isScalar(value) {
    return (!isPlainObject(value) && !isFunction(value)) || isNull(value) || isUndefined(value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/isTruthyIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns whether or not the nested property is defined. Keys may be an
 * _array, or a dot-delimited _string of properties.
 *
 * @param {?} object
 * @param {?} keys
 * boolean
 * @return {?}
 */
function isTruthyIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return isTruthy(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/ixIsMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} src
 * @param {?} mapCompare
 * @return {?}
 */
function ixIsMatch(src, mapCompare) {
    /** @type {?} */
    let _isMatchTest = isObject(src) && isObject(mapCompare);
    if (_isMatchTest) {
        for (const prop in mapCompare) {
            if (mapCompare.hasOwnProperty(prop)) {
                /** @type {?} */
                const srcValue = getIn(src, prop);
                /** @type {?} */
                const cmpValue = mapCompare[prop];
                // bool values does not work with lodash isMatch
                if (isScalar(srcValue) && isScalar(cmpValue)) {
                    if (!(_isMatchTest && srcValue === cmpValue)) {
                        _isMatchTest = false;
                        break;
                    }
                }
                else if (!(_isMatchTest && hasValue(srcValue) && hasValue(cmpValue) && isMatch(srcValue, cmpValue))) {
                    _isMatchTest = false;
                    break;
                }
            }
        }
    }
    return _isMatchTest;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayReduce.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * Returns the accumulated value.
 *
 * @param {?} array [_array] The _array to iterate over.
 * @param {?} iteratee {Function} iteratee The function invoked per iteration.
 * @param {?} accumulator {*} [accumulator] The initial value.
 * @param {?=} initAccum {boolean} [initAccum] Specify using the first element of `_array` as
 * @return {?}
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    if (initAccum && length) {
        accumulator = array[++index];
    }
    while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_asciiWords.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to match words composed of alphanumeric characters.
 * @type {?}
 */
const reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `_string` into an _array of its words.
 *
 * Returns the words of `_string`.
 *
 * @param {?} string The _string to inspect.
 * @return {?}
 */
function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_hasUnicodeWord.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line
/**
 * Used to detect strings that need a more robust regexp to match words.
 * @type {?}
 */
const reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `_string` contains a word composed of Unicode symbols.
 *
 * Returns `true` if a word is found, else `false`.
 *
 * @param {?} string _string The _string to inspect.
 * @return {?}
 */
function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_unicodeWords.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable
/**
 * Used to compose unicode character classes.
 * @type {?}
 */
const rsAstralRange$2 = '\\ud800-\\udfff';
/** @type {?} */
const rsComboMarksRange$3 = '\\u0300-\\u036f';
/** @type {?} */
const reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f';
/** @type {?} */
const rsComboSymbolsRange$3 = '\\u20d0-\\u20ff';
/** @type {?} */
const rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;
/** @type {?} */
const rsDingbatRange = '\\u2700-\\u27bf';
/** @type {?} */
const rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff';
/** @type {?} */
const rsMathOpRange = '\\xac\\xb1\\xd7\\xf7';
/** @type {?} */
const rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf';
/** @type {?} */
const rsPunctuationRange = '\\u2000-\\u206f';
/** @type {?} */
const 
// tslint:disable-next-line
rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000';
/** @type {?} */
const rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde';
/** @type {?} */
const rsVarRange$2 = '\\ufe0e\\ufe0f';
/** @type {?} */
const rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
// tslint:disable-next-line
/**
 * Used to compose unicode capture groups.
 * @type {?}
 */
const rsApos = "['\u2019]";
/** @type {?} */
const rsBreak = '[' + rsBreakRange + ']';
/** @type {?} */
const rsCombo$2 = '[' + rsComboRange$3 + ']';
/** @type {?} */
const rsDigits = '\\d+';
/** @type {?} */
const rsDingbat = '[' + rsDingbatRange + ']';
/** @type {?} */
const rsLower = '[' + rsLowerRange + ']';
/** @type {?} */
const rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']';
/** @type {?} */
const rsFitz$1 = '\\ud83c[\\udffb-\\udfff]';
/** @type {?} */
const rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')';
/** @type {?} */
const rsNonAstral$1 = '[^' + rsAstralRange$2 + ']';
/** @type {?} */
const rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}';
/** @type {?} */
const rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]';
/** @type {?} */
const rsUpper = '[' + rsUpperRange + ']';
/** @type {?} */
const rsZWJ$2 = '\\u200d';
/**
 * Used to compose unicode regexes.
 * @type {?}
 */
const rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')';
/** @type {?} */
const rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')';
/** @type {?} */
const rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?';
/** @type {?} */
const rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?';
/** @type {?} */
const reOptMod$1 = rsModifier$1 + '?';
/** @type {?} */
const rsOptVar$1 = '[' + rsVarRange$2 + ']?';
/** @type {?} */
const rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*';
/** @type {?} */
const rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])';
/** @type {?} */
const rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])';
/** @type {?} */
const rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1;
/** @type {?} */
const rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;
/**
 * Used to match complex or compound words.
 * @type {?}
 */
const reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji,
].join('|'), 'g');
// tslint:enable
/**
 * Splits a Unicode `_string` into an _array of its words.
 *
 * Returns the words of `_string`.
 * @param {?} string The _string to inspect.
 * @return {?}
 */
function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/words.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Splits `_string` into an _array of its words.
 * Returns the words of `_string`.
 * @param {?} string [_string=''] The _string to inspect.
 * @param {?=} pattern {RegExp|string} [pattern] The pattern to match words.
 * @param {?=} guard {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 * @return {?}
 */
function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    }
    return string.match(pattern) || [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_createCompounder.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line
/**
 * Used to compose unicode capture groups.
 * @type {?}
 */
const rsApos$1 = "['\u2019]";
/**
 * Used to match apostrophes.
 * @type {?}
 */
const reApos = RegExp(rsApos$1, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * Returns the new compounder function.
 *
 * @param {?} callback callback The function to combine each word.
 * @return {?}
 */
function createCompounder(callback) {
    return (/**
     * @param {?} string
     * @return {?}
     */
    function (string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/kebabCase.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$5 = /**
 * @param {?} result
 * @param {?} word
 * @param {?} index
 * @return {?}
 */
function (result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
};
/**
 * Converts `_string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 * Returns Function: the kebab cased _string.
 *
 * \@param _string {string} [_string=''] The _string to convert.
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 * @type {?}
 */
const kebabCase = createCompounder((ɵ0$5));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseAssignValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @param {?} object The _object to modify.
 * @param {?} key The key of the property to assign.
 * @param {?} value The value to assign.
 * @return {?}
 */
function baseAssignValue(object, key, value) {
    if (key === '__proto__' && defineProperty) {
        defineProperty(object, key, {
            configurable: true,
            enumerable: true,
            value: value,
            writable: true,
        });
    }
    else {
        object[key] = value;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_assignMergeValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @param {?} object The _object to modify.
 * @param {?} key The key of the property to assign.
 * @param {?} value The value to assign.
 * @return {?}
 */
function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq(object[key], value)) || (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_cloneBuffer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Detect free variable `exports`.
 * @type {?}
 */
const freeExports$2 = typeof exports === 'object' && exports && !exports.nodeType && exports;
/**
 * Detect free variable `module`.
 * @type {?}
 */
const freeModule$2 = freeExports$2 && typeof module === 'object' && module && !module.nodeType && module;
/**
 * Detect the popular CommonJS extension `module.exports`.
 * @type {?}
 */
const moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/**
 * Built-in value references.
 * @type {?}
 */
const Buffer$1 = moduleExports$2 ? root.Buffer : undefined;
/** @type {?} */
const allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @param {?} buffer The buffer to clone.
 * @param {?=} isDeep Specify a deep clone.
 * Returns the cloned buffer.
 * @return {?}
 */
function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
        return buffer.slice();
    }
    /** @type {?} */
    const length = buffer.length;
    /** @type {?} */
    const result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_cloneArrayBuffer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @param {?} arrayBuffer The _array buffer to clone.
 * Returns the cloned _array buffer.
 * @return {?}
 */
function cloneArrayBuffer(arrayBuffer) {
    /** @type {?} */
    const result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_cloneTypedArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a clone of `typedArray`.
 *
 * @param {?} typedArray The typed _array to clone.
 * @param {?=} isDeep Specify a deep clone.
 * Returns the cloned typed _array.
 * @return {?}
 */
function cloneTypedArray(typedArray, isDeep) {
    /** @type {?} */
    const buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_copyArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Copies the values of `source` to `_array`.
 *
 * @param {?} source The _array to copy values from.
 * @param {?=} array The _array to copy values to.
 * Returns `_array`.
 * @return {?}
 */
function copyArray(source, array) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = source.length;
    array = array ? array : Array(length);
    while (++index < length) {
        array[index] = source[index];
    }
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseCreate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Built-in value references.
 * @type {?}
 */
const objectCreate = Object.create;
const ɵ0$6 = /**
 * @return {?}
 */
function () {
    /**
     * @return {?}
     */
    function object() { }
    return (/**
     * @param {?} proto
     * @return {?}
     */
    function (proto) {
        if (!isObject(proto)) {
            return {};
        }
        if (objectCreate) {
            return objectCreate(proto);
        }
        object.prototype = proto;
        /** @type {?} */
        const result = new object();
        object.prototype = undefined;
        return result;
    });
};
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created _object.
 *
 * \@param proto The _object to inherit from.
 * Returns the new _object.
 * @type {?}
 */
const baseCreate = ((ɵ0$6))();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_initCloneObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Initializes an _object clone.
 *
 * @param {?} object The _object to clone.
 * Returns the initialized clone.
 * @return {?}
 */
function initCloneObject(object) {
    return typeof object.constructor === 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_safeGet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @param {?} object The _object to query.
 * @param {?} key The key of the property to get.
 * Returns the property value.
 * @return {?}
 */
function safeGet(object, key) {
    return key === '__proto__' ? undefined : object[key];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_assignValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const objectProto$f = Object.prototype;
/**
 * Used to check objects for own properties.
 * @type {?}
 */
const hasOwnProperty$c = objectProto$f.hasOwnProperty;
/**
 * Assigns `value` to `key` of `_object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @param {?} object The _object to modify.
 * @param {?} key The key of the property to assign.
 * @param {?} value The value to assign.
 * @return {?}
 */
function assignValue(object, key, value) {
    /** @type {?} */
    const objValue = object[key];
    if (!(hasOwnProperty$c.call(object, key) && eq(objValue, value)) || (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_copyObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Copies properties of `source` to `_object`.
 *
 * @param {?} source The _object to copy properties from.
 * @param {?} props The property identifiers to copy.
 * @param {?=} object to copy properties to.
 * @param {?=} customizer The function to customize copied values.
 * Returns `_object`.
 * @return {?}
 */
function copyObject(source, props, object = {}, customizer) {
    /** @type {?} */
    const isNew = !object;
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = props.length;
    while (++index < length) {
        /** @type {?} */
        const key = props[index];
        /** @type {?} */
        let newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) {
            newValue = source[key];
        }
        if (isNew) {
            baseAssignValue(object, key, newValue);
        }
        else {
            assignValue(object, key, newValue);
        }
    }
    return object;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/toPlainObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Converts `value` to a plain _object flattening inherited enumerable _string
 * keyed properties of `value` to own properties of the plain _object.
 *
 * @param {?} value The value to convert.
 * Returns the converted plain _object.
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 * @return {?}
 */
function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseMergeDeep.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @param {?} object The destination _object.
 * @param {?} source The source _object.
 * @param {?} key The key of the value to merge.
 * @param {?} srcIndex The index of `source`.
 * @param {?} mergeFunc The function to merge values.
 * @param {?=} customizer The function to customize assigned values.
 * @param {?=} stack Tracks traversed source values and their merged
 *  counterparts.
 * @return {?}
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    /** @type {?} */
    const objValue = safeGet(object, key);
    /** @type {?} */
    const srcValue = safeGet(source, key);
    /** @type {?} */
    const stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    /** @type {?} */
    let newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    /** @type {?} */
    let isCommon = newValue === undefined;
    if (isCommon) {
        /** @type {?} */
        const isArr = isArray(srcValue);
        /** @type {?} */
        const isBuff = !isArr && isBuffer(srcValue);
        /** @type {?} */
        const isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
                newValue = objValue;
            }
            else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
            }
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            }
            else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            }
            else {
                newValue = [];
            }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
            }
            else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
                newValue = initCloneObject(srcValue);
            }
        }
        else {
            isCommon = false;
        }
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseMerge.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @param {?} object The destination _object.
 * @param {?} source The source _object.
 * @param {?} srcIndex The index of `source`.
 * @param {?=} customizer The function to customize merged values.
 * @param {?=} stack Tracks traversed source values and their merged
 *  counterparts.
 * @return {?}
 */
function baseMerge(object, source, srcIndex, customizer, stack = new Stack()) {
    if (object === source) {
        return;
    }
    baseFor(source, (/**
     * @param {?} srcValue
     * @param {?} key
     * @return {?}
     */
    function (srcValue, key) {
        if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
            /** @type {?} */
            let newValue = customizer
                ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack)
                : undefined;
            if (newValue === undefined) {
                newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
        }
    }), keysIn);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_isIterateeCall.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @param {?} value The potential iteratee value argument.
 * @param {?} index The potential iteratee index or key argument.
 * @param {?} object The potential iteratee _object argument.
 * Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 * @return {?}
 */
function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
        return false;
    }
    /** @type {?} */
    const type = typeof index;
    if (type === 'number' ? isArrayLike(object) && isIndex(index, object.length) : type === 'string' && index in object) {
        return eq(object[index], value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_createAssigner.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a function like `_.assign`.
 *
 * @param {?} assigner The function to assign values.
 * Returns the new assigner function.
 * @return {?}
 */
function createAssigner(assigner) {
    return baseRest((/**
     * @param {?} object
     * @param {?} sources
     * @return {?}
     */
    function (object, sources) {
        /** @type {?} */
        let index = -1;
        /** @type {?} */
        let length = sources.length;
        /** @type {?} */
        let customizer = length > 1 ? sources[length - 1] : undefined;
        /** @type {?} */
        const guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer === 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while (++index < length) {
            /** @type {?} */
            const source = sources[index];
            if (source) {
                assigner(object, source, index, customizer);
            }
        }
        return object;
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/merge.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$7 = /**
 * @param {?} object
 * @param {?} source
 * @param {?=} srcIndex
 * @return {?}
 */
function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
};
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable _string keyed properties of source objects into the
 * destination _object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain _object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `_object`.
 *
 * \@param _object The destination _object.
 * \@param source {...Object} [sources] The source objects.
 * Returns `_object`.
 *
 * var _object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(_object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 * @type {?}
 */
const merge = createAssigner((ɵ0$7));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/mergeWith.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$8 = /**
 * @param {?} object
 * @param {?} source
 * @param {?} srcIndex
 * @param {?} customizer
 * @return {?}
 */
function (object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
};
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, _object, source, stack).
 *
 * **Note:** This method mutates `_object`.
 *
 * \@param _object The destination _object.
 * \@param sources The source objects. {...Object}
 * \@param customizer The function to customize assigned values.
 * Returns `_object`.
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var _object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(_object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 * @type {?}
 */
const mergeWith = createAssigner((ɵ0$8));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/mergeWithoutArray.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} target
 * @param {?} source
 * @return {?}
 */
function mergeWithoutArray(target, source) {
    return mergeWith(clone(target), clone(source), mergeCustomizer);
}
/**
 * @param {?} targetValue
 * @param {?} srcValue
 * @return {?}
 */
function mergeCustomizer(targetValue, srcValue) {
    if (isArray(targetValue) || isBoolean(srcValue)) {
        return srcValue;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.set`.
 *
 * @template T
 * @param {?} object The _object to modify.
 * @param {?} path The path of the property to set.
 * @param {?} value The value to set.
 * @param {?=} customizer The function to customize path creation.
 * Returns `_object`.
 * @return {?}
 */
function baseSet(object, path, value, customizer) {
    if (!isObject(object)) {
        return object;
    }
    path = castPath(path, object);
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = path.length;
    /** @type {?} */
    const lastIndex = length - 1;
    /** @type {?} */
    let nested = object;
    while (nested != null && ++index < length) {
        /** @type {?} */
        const key = toKey(path[index]);
        /** @type {?} */
        let newValue = value;
        if (index !== lastIndex) {
            /** @type {?} */
            const objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/setIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets the value at `path` of `_object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `_object`.
 *
 * @param {?} object The _object to modify.
 * @param {?} path The path of the property to set.
 * @param {?} value The value to set.
 * Returns `_object`.
 *
 * var _object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(_object, 'a[0].b.c', 4);
 * console.log(_object.a[0].b.c);
 * // => 4
 *
 * _.set(_object, ['x', '0', 'y', 'z'], 5);
 * console.log(_object.x[0].y.z);
 * // => 5
 * @return {?}
 */
function setIn(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/mergeIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @param {?} keys
 * @param {?} value
 * @return {?}
 */
function mergeIn(object, keys, value) {
    if (!hasValue(keys)) {
        return mergeWithoutArray(clone(object), value);
    }
    else {
        /** @type {?} */
        const originalValue = getIn(object, keys);
        /** @type {?} */
        const newValue = mergeWithoutArray(originalValue, value);
        return setIn(clone(object), keys, newValue);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/propsWithNoValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} obj
 * @return {?}
 */
function propsWithNoValue(obj) {
    /** @type {?} */
    const r = {};
    Object.keys(obj).forEach((/**
     * @param {?} key
     * @return {?}
     */
    (key) => {
        if (!hasValue(obj[key])) {
            r[key] = obj[key];
        }
    }));
    return r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/mergePropsIfNoValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} target
 * @param {?} source
 * @param {?=} exclude
 * @return {?}
 */
function mergePropsIfNoValue(target, source, exclude) {
    /** @type {?} */
    const e = exclude ? exclude : [];
    // get only the properties that have no value
    // from the target _object
    /** @type {?} */
    const t = propsWithNoValue(target);
    /** @type {?} */
    const keys = Object.keys(t);
    // make target immutable
    /** @type {?} */
    const r = clone(target);
    keys.forEach((/**
     * @param {?} key
     * @return {?}
     */
    (key) => {
        if (e.indexOf(key) === -1) {
            if (hasValue(source[key])) {
                r[key] = source[key];
            }
        }
    }));
    return r;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/mergePropsIfSourceHasValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Only merge a value from a source object to the target object if it has value
 * @param {?} target
 * @param {?} source
 * @return {?}
 */
function mergePropsIfSourceHasValue(target, source) {
    if (!isPlainObject(source)) {
        return target;
    }
    /** @type {?} */
    const sourceKeys = Object.keys(source);
    // Walk over keys of source object
    for (let i = 0; i < sourceKeys.length; i++) {
        /** @type {?} */
        const key = sourceKeys[i];
        // Only merge source keys that are NOT null or undefined
        if (hasValue(source[key])) {
            // if target and source key is an object, recurse
            if (isPlainObject(target[key]) && isPlainObject(source[key])) {
                // Don't pass encapsulated context of container function
                target[key] = mergePropsIfSourceHasValue.apply(null, [target[key], source[key]]);
            }
            else {
                // Should be assigning scalar values at this point
                target[key] = source[key];
            }
        }
    }
    return target;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseIndexOfWith.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @param {?} array The _array to inspect.
 * @param {?} value The value to search for.
 * @param {?} fromIndex The index to search from.
 * @param {?=} comparator The comparator invoked per element.
 * Returns the index of the matched value, else `-1`.
 * @return {?}
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
    /** @type {?} */
    let index = fromIndex - 1;
    /** @type {?} */
    const length = array.length;
    while (++index < length) {
        if (comparator(array[index], value)) {
            return index;
        }
    }
    return -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_basePullAll.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used for built-in method references.
 * @type {?}
 */
const arrayProto$1 = Array.prototype;
/**
 * Built-in value references.
 * @type {?}
 */
const splice$1 = arrayProto$1.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @param {?} array The _array to modify.
 * @param {?} values The values to remove.
 * @param {?=} iteratee [iteratee] The iteratee invoked per element.
 * @param {?=} comparator [comparator] The comparator invoked per element.
 * Returns `_array`.
 * @return {?}
 */
function basePullAll(array, values, iteratee, comparator) {
    /** @type {?} */
    const indexOf = comparator ? baseIndexOfWith : baseIndexOf;
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = values.length;
    /** @type {?} */
    let seen = array;
    if (array === values) {
        values = copyArray(values);
    }
    if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
    }
    while (++index < length) {
        /** @type {?} */
        let fromIndex = 0;
        /** @type {?} */
        const value = values[index];
        /** @type {?} */
        const computed = iteratee ? iteratee(value) : value;
        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
                splice$1.call(seen, fromIndex, 1);
            }
            splice$1.call(array, fromIndex, 1);
        }
    }
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/pullAllBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `_array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `_array`.
 *
 * \@example
 *
 * var _array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(_array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(_array);
 * // => [{ 'x': 2 }]
 * @param {?} array The _array to modify.
 * @param {?} values The values to remove.
 * @param {?=} iteratee [iteratee=_.identity] The iteratee invoked per element.
 * Returns `_array`.
 * @return {?}
 */
function pullAllBy(array, values, iteratee) {
    return array && array.length && values && values.length
        ? basePullAll(array, values, baseIteratee(iteratee, 2))
        : array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/removeAllBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} array
 * @param {?} values
 * @param {?} iteratee
 * @return {?}
 */
function removeAllBy(array, values, iteratee) {
    return array.slice().reduce((/**
     * @param {?} acc
     * @param {?} item
     * @return {?}
     */
    (acc, item) => {
        /** @type {?} */
        let isSelected = [];
        if (isString(iteratee)) {
            isSelected = values.filter((/**
             * @param {?} selectedItem
             * @return {?}
             */
            (selectedItem) => {
                return selectedItem[(/** @type {?} */ (iteratee))] === item[(/** @type {?} */ (iteratee))];
            }));
        }
        if (isFunction(iteratee)) {
            isSelected = values.filter((/**
             * @param {?} selectedItem
             * @return {?}
             */
            (selectedItem) => {
                return ((/** @type {?} */ (iteratee))).apply(null, [item, selectedItem]);
            }));
        }
        if (!isSelected.length) {
            acc.push(item);
        }
        return acc;
    }), []);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/ternary.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} ifHasValue
 * @param {?} elseValue
 * @return {?}
 */
function ternary(ifHasValue, elseValue) {
    return hasValue(ifHasValue) ? ifHasValue : elseValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/ternaryIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Return value of nested node if node has a value,
 * else return conditional value.
 *
 * ternaryIn(_object: 'prop1.prop2[0].prop3', alternateValue);
 * @param {?} object
 * @param {?} keys
 * @param {?} elseValue
 * @return {?}
 */
function ternaryIn(object, keys, elseValue) {
    // getIn or get Will return value of any key defined
    // even if value is null or undefined
    return ternary(getIn(object, keys), elseValue);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/setInIfSrc.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sets the nested key to the provided value only if the property exists.
 *
 * If you have for example:
 * if (target && target.prop && target.prop.prop2 {
 *    target.prop.prop2 = someValue;
 * }
 *
 * Then you can use:
 * setInIfSrc(target, 'prop.prop2', someValue);
 *
 * @param {?} srcObject
 * @param {?} srcKeys
 * @param {?} targetObject
 * @param {?} targetKeys
 * @param {?=} defaultValue
 * @return {?}
 */
function setInIfSrc(srcObject, srcKeys, targetObject, targetKeys, defaultValue) {
    /** @type {?} */
    const _value = ternaryIn(srcObject, srcKeys, defaultValue);
    // if defaultValue is used, validate it
    if (hasValue(_value)) {
        setIn(targetObject, targetKeys, _value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/setInIfSrcWithConfig.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ISetInSrcConfig() { }
if (false) {
    /** @type {?} */
    ISetInSrcConfig.prototype.src;
    /** @type {?} */
    ISetInSrcConfig.prototype.srcKeys;
    /** @type {?} */
    ISetInSrcConfig.prototype.target;
    /** @type {?} */
    ISetInSrcConfig.prototype.targetKeys;
    /** @type {?|undefined} */
    ISetInSrcConfig.prototype.defaultValue;
}
/**
 * @param {?} config
 * @return {?}
 */
function setInIfSrcWithConfig(config) {
    setInIfSrc(config.src, config.srcKeys, config.target, config.targetKeys, config.defaultValue);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseRandom.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Built-in method references for those with the same name as other `lodash` methods. */
/** @type {?} */
const nativeFloor = Math.floor;
/** @type {?} */
const nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @param {?} lower The lower bound.
 * @param {?} upper The upper bound.
 * Returns the random _number.
 * @return {?}
 */
function baseRandom(lower, upper) {
    return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_shuffleSelf.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `_array`.
 *
 * @param {?} array The _array to shuffle.
 * @param {?=} size [size=_array.length] The size of `_array`.
 * Returns `_array`.
 * @return {?}
 */
function shuffleSelf(array, size) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array.length;
    /** @type {?} */
    const lastIndex = length - 1;
    size = size === undefined ? length : size;
    while (++index < size) {
        /** @type {?} */
        const rand = baseRandom(index, lastIndex);
        /** @type {?} */
        const value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayShuffle.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @param {?} array The _array to shuffle.
 * Returns the new shuffled _array.
 * @return {?}
 */
function arrayShuffle(array) {
    return shuffleSelf(copyArray(array));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseShuffle.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.shuffle`.
 *
 * @param {?} collection The collection to shuffle.
 * Returns the new shuffled _array.
 * @return {?}
 */
function baseShuffle(collection) {
    return shuffleSelf(values(collection));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/shuffle.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates an _array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @param {?} collection The collection to shuffle.
 * Returns the new shuffled _array.
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 * @return {?}
 */
function shuffle(collection) {
    /** @type {?} */
    const func = isArray(collection) ? arrayShuffle : baseShuffle;
    return func(collection);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseForOwn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @param {?} object The _object to iterate over.
 * @param {?} iteratee The function invoked per iteration.
 * Returns `_object`.
 * @return {?}
 */
function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_createBaseEach.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @param {?} eachFunc {Function} eachFunc The function to iterate over a collection.
 * @param {?=} fromRight {boolean} [fromRight] Specify iterating from right to left.
 * Returns the new base function.
 * @return {?}
 */
function createBaseEach(eachFunc, fromRight) {
    return (/**
     * @param {?} collection
     * @param {?} iteratee
     * @return {?}
     */
    function (collection, iteratee) {
        if (collection == null) {
            return collection;
        }
        if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
        }
        /** @type {?} */
        const length = collection.length;
        /** @type {?} */
        let index = fromRight ? length : -1;
        /** @type {?} */
        const iterable = Object(collection);
        while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
                break;
            }
        }
        return collection;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseEach.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * \@param collection {Array|Object} collection The collection to iterate over.
 * \@param iteratee {Function} iteratee The function invoked per iteration.
 * Returns `collection`.
 * @type {?}
 */
let baseEach = createBaseEach(baseForOwn);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseMap.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @param {?} collection The collection to iterate over.
 * @param {?} iteratee The function invoked per iteration.
 * @return {?}
 */
function baseMap(collection, iteratee) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, (/**
     * @param {?} value
     * @param {?} key
     * @param {?} _collection
     * @return {?}
     */
    function (value, key, _collection) {
        result[++index] = iteratee(value, key, _collection);
    }));
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseSortBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `_array` and replaces criteria objects with their corresponding
 * values.
 *
 * @param {?} array The _array to sort.
 * @param {?} comparer The function to define sort order.
 * @return {?}
 */
function baseSortBy(array, comparer) {
    /** @type {?} */
    let length = array.length;
    array.sort(comparer);
    while (length--) {
        array[length] = array[length].value;
    }
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_compareAscending.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Compares values to sort them in ascending order.
 *
 * @param {?} value The value to compare.
 * @param {?} other The other value to compare.
 * @return {?}
 */
function compareAscending(value, other) {
    if (value !== other) {
        /** @type {?} */
        const valIsDefined = value !== undefined;
        /** @type {?} */
        const valIsNull = value === null;
        /** @type {?} */
        const valIsReflexive = value === value;
        /** @type {?} */
        const valIsSymbol = isSymbol(value);
        /** @type {?} */
        const othIsDefined = other !== undefined;
        /** @type {?} */
        const othIsNull = other === null;
        /** @type {?} */
        const othIsReflexive = other === other;
        /** @type {?} */
        const othIsSymbol = isSymbol(other);
        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
            return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
            return -1;
        }
    }
    return 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_compareMultiple.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @param {?} object The _object to compare.
 * @param {?} other The other _object to compare.
 * @param {?} orders The order to sort by for each property.
 * @return {?}
 */
function compareMultiple(object, other, orders) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const objCriteria = object.criteria;
    /** @type {?} */
    const othCriteria = other.criteria;
    /** @type {?} */
    const length = objCriteria.length;
    /** @type {?} */
    const ordersLength = orders.length;
    while (++index < length) {
        /** @type {?} */
        const result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) {
                return result;
            }
            /** @type {?} */
            const order = orders[index];
            return result * (order === 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `_object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseOrderBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @param {?} collection The collection to iterate over.
 * @param {?} iteratees The iteratees to sort by.
 * @param {?} orders The sort orders of `iteratees`.
 * @return {?}
 */
function baseOrderBy(collection, iteratees, orders) {
    /** @type {?} */
    let index = -1;
    iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
    /** @type {?} */
    const result = baseMap(collection, (/**
     * @param {?} value
     * @param {?} key
     * @param {?} _collection
     * @return {?}
     */
    function (value, key, _collection) {
        /** @type {?} */
        const criteria = arrayMap(iteratees, (/**
         * @param {?} iteratee
         * @return {?}
         */
        function (iteratee) {
            return iteratee(value);
        }));
        return { criteria: criteria, index: ++index, value: value };
    }));
    return baseSortBy(result, (/**
     * @param {?} object
     * @param {?} other
     * @return {?}
     */
    function (object, other) {
        return compareMultiple(object, other, orders);
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/sortBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$9 = /**
 * @param {?} collection
 * @param {?} iteratees
 * @return {?}
 */
function (collection, iteratees) {
    if (collection == null) {
        return [];
    }
    /** @type {?} */
    const length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
    }
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
    }
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
};
/**
 * Creates an _array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * \@category Collection
 * \@param collection The collection to iterate over.
 * \@param iteratees
 * \@example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 * @type {?}
 */
const sortBy = baseRest((ɵ0$9));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_arrayEach.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @param {?} array
 * @param {?} iteratee The function invoked per iteration.
 * @return {?}
 */
function arrayEach(array, iteratee) {
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    const length = array == null ? 0 : array.length;
    while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
            break;
        }
    }
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/transform.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An alternative to `_.reduce`; this method transforms `_object` to a new
 * `accumulator` _object which is the result of running each of its own
 * enumerable _string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` _object. If `accumulator` is not
 * provided, a new _object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, _object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 *
 * \@memberOf _
 * \@since 1.3.0
 * \@category Object
 * \@example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 * @param {?} object The _object to iterate over.
 * @param {?} iteratee
 * @param {?=} accumulator
 * @return {?}
 */
function transform(object, iteratee, accumulator) {
    /** @type {?} */
    const isArr = isArray(object);
    /** @type {?} */
    const isArrLike = isArr || isBuffer(object) || isTypedArray(object);
    iteratee = baseIteratee(iteratee, 4);
    if (accumulator === null || accumulator === undefined) {
        /** @type {?} */
        const Ctor = object && object.constructor;
        if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
        }
        else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
            accumulator = {};
        }
    }
    (isArrLike ? arrayEach : baseForOwn)(object, (/**
     * @param {?} value
     * @param {?} index
     * @param {?} _object
     * @return {?}
     */
    function (value, index, _object) {
        return iteratee(accumulator, value, index, _object);
    }));
    return accumulator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/noop.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method returns `undefined`.
 *
 *
 * \@memberOf _
 * \@since 2.3.0
 * \@category Util
 * \@example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 * @return {?}
 */
function noop() {
    // No operation performed.
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_createSet.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as references for various `Number` constants.
 * @type {?}
 */
const INFINITY$3 = 1 / 0;
/**
 * Creates a set _object of `values`.
 *
 * \@param values {Array} values The values to add to the set.
 * Returns the new set.
 * @type {?}
 */
let createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] === INFINITY$3)
    ? noop
    : (/**
     * @param {?} values
     * @return {?}
     */
    function (values) {
        return new Set(values);
    });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/_baseUniq.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used as the size to enable large _array optimizations.
 * @type {?}
 */
const LARGE_ARRAY_SIZE$2 = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @param {?} array {Array} _array The _array to inspect.
 * @param {?=} iteratee {Function} [iteratee] The iteratee invoked per element.
 * @param {?=} comparator {Function} [comparator] The comparator invoked per element.
 * @return {?}
 */
function baseUniq(array, iteratee, comparator) {
    /** @type {?} */
    const length = array.length;
    /** @type {?} */
    const result = [];
    /** @type {?} */
    let index = -1;
    /** @type {?} */
    let includes = arrayIncludes;
    /** @type {?} */
    let isCommon = true;
    /** @type {?} */
    let seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    }
    else if (length >= LARGE_ARRAY_SIZE$2) {
        /** @type {?} */
        const set = iteratee ? null : createSet(array);
        if (set) {
            return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache();
    }
    else {
        seen = iteratee ? [] : result;
    }
    outer: while (++index < length) {
        /** @type {?} */
        let value = array[index];
        /** @type {?} */
        const computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            /** @type {?} */
            let seenIndex = seen.length;
            while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                    continue outer;
                }
            }
            if (iteratee) {
                seen.push(computed);
            }
            result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
                seen.push(computed);
            }
            result.push(value);
        }
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/uniq.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Creates a duplicate-free version of an _array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the _array.
 *
 * \@category Array
 * \@example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 * @param {?} array The _array to inspect.
 * @return {?}
 */
function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/uniqBy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `_array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the _array. The iteratee is invoked with one argument:
 * (value).
 *
 * \@category Array
 * \@example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 * @param {?} array The _array to inspect.
 * @param {?} iteratee
 * @return {?}
 */
function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/uniqueId.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Used to generate unique IDs.
 * @type {?}
 */
let idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * \@category Util
 * \@example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 * @param {?} prefix
 * @return {?}
 */
function uniqueId(prefix) {
    /** @type {?} */
    const id = ++idCounter;
    return toString(prefix) + id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_common/uniqWith.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `_array`. The order of result values is
 * determined by the order they occur in the _array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * \@category Array
 * \@example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 * @param {?} array The _array to inspect.
 * @param {?} comparator
 * @return {?}
 */
function uniqWith(array, comparator) {
    comparator = typeof comparator === 'function' ? comparator : undefined;
    return array && array.length ? baseUniq(array, undefined, comparator) : [];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_date/millisecond.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/*
x = ms / 1000
seconds = x % 60
x /= 60
minutes = x % 60
x /= 60
hours = x % 24
x /= 24
days = x
 */
/**
 * @param {?} _ms
 * @return {?}
 */
function msToSec(_ms) {
    return parseInt((/** @type {?} */ (_ms)), 10) / 1000;
}
/**
 * @param {?} _s
 * @return {?}
 */
function secToMs(_s) {
    return parseInt((/** @type {?} */ (_s)), 10) * 1000;
}
/**
 * @param {?} _ms
 * @return {?}
 */
function msToMins(_ms) {
    return msToSec(_ms) / 60;
}
/**
 * @param {?} _m
 * @return {?}
 */
function minToMs(_m) {
    return secToMs(_m) * 60;
}
/**
 * @param {?} _ms
 * @return {?}
 */
function msToHours(_ms) {
    return msToMins(_ms) / 60;
}
/**
 * @param {?} _h
 * @return {?}
 */
function hourToMs(_h) {
    return minToMs(_h) * 60;
}
/**
 * @param {?} _ms
 * @return {?}
 */
function msToDays(_ms) {
    return msToHours(_ms) / 24;
}
/**
 * @param {?} _d
 * @return {?}
 */
function dayToMs(_d) {
    return hourToMs(_d) * 24;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_guid/uuid.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/* jshint bitwise:false, node:true */
/* tslint:disable:no-bitwise no-var-keyword typedef */
// taken from TodoMVC
/**
 * @return {?}
 */
function uuid() {
    /** @type {?} */
    var i;
    /** @type {?} */
    var random;
    /** @type {?} */
    var result = '';
    for (i = 0; i < 32; i++) {
        random = (Math.random() * 16) | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            result += '-';
        }
        result += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
    }
    return result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/_internal.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function convertToNumber(value) {
    /** @type {?} */
    let _value;
    if (isString(value)) {
        _value = parseFloat(value.toString());
    }
    else {
        _value = Number(value);
    }
    return _value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/isInteger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isInteger(value) {
    /** @type {?} */
    const _value = convertToNumber(value);
    return isNumber(_value) && isFinite(_value) && Math.floor(_value) === _value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/isArrayInteger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isArrayInteger(value) {
    /** @type {?} */
    const _value = convertToNumber(value);
    return isInteger(_value) && _value > -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/isPostiveInteger.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function isPostiveInteger(value) {
    /** @type {?} */
    const _value = convertToNumber(value);
    return isInteger(_value) && _value > 0;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_number/randomInt.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/**
 * Return a random integer between
 * minimum and maximum values.
 *
 * @param {?} min - minimum range to generate random integer.
 * @param {?} max - maximum range to generate random integer.
 * @return {?} number
 */
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/_interfaces.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ISearchObjectByKeysResult() { }
if (false) {
    /** @type {?} */
    ISearchObjectByKeysResult.prototype.key;
    /** @type {?} */
    ISearchObjectByKeysResult.prototype.path;
    /** @type {?} */
    ISearchObjectByKeysResult.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesDefined.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @return {?}
 */
function allValuesDefined(object) {
    if (isPlainObject(object)) {
        if (!isEmpty(object)) {
            return Object.keys(object).reduce((/**
             * @param {?} _allValuesDefined
             * @param {?} key
             * @return {?}
             */
            (_allValuesDefined, key) => {
                if (!_allValuesDefined) {
                    return _allValuesDefined;
                }
                return isDefined(object[key]);
            }), true);
        }
        else {
            // _object is empty
            return false;
        }
    }
    else {
        // not isPlainObject
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesDefinedIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns whether or not the nested property is defined. Keys may be an
 * _array, or a dot-delimited _string of properties.
 * @param {?} object
 * @param {?} keys
 * @return {?}
 */
function allValuesDefinedIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return allValuesDefined(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesHasValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object to evaluate
 * @return {?}
 */
function allValuesHasValue(object) {
    if (isPlainObject(object)) {
        if (!isEmpty(object)) {
            return Object.keys(object).reduce((/**
             * @param {?} _allPropsHaveValue
             * @param {?} key
             * @return {?}
             */
            (_allPropsHaveValue, key) => {
                if (!_allPropsHaveValue) {
                    return _allPropsHaveValue;
                }
                return hasValue(object[key]);
            }), true);
        }
        else {
            // _object is empty
            return false;
        }
    }
    else {
        // not plain _object
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesHasValueIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object to evaluate
 * @param {?} keys path to value such as a.b.c[2].d
 * @return {?}
 */
function allValuesHasValueIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return allValuesHasValue(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IAllValuesMatchConfig() { }
if (false) {
    /** @type {?|undefined} */
    IAllValuesMatchConfig.prototype.includeArrays;
    /** @type {?|undefined} */
    IAllValuesMatchConfig.prototype.excludeKeys;
}
/**
 * @param {?} key
 * @param {?} keys
 * @return {?}
 */
function keyIsExcludedIn(key, keys) {
    return !!keys.filter((/**
     * @param {?} _key
     * @return {?}
     */
    (_key) => key === _key)).length;
}
/**
 * @param {?} src
 * @param {?} tar
 * @param {?=} config
 * @return {?}
 */
function allValuesMatch(src, tar, config) {
    if (isDefined(src) && isDefined(tar)) {
        /** @type {?} */
        const keys = Object.keys(tar);
        /** @type {?} */
        const includeArrays = config && hasValue(config.includeArrays) ? config.includeArrays : false;
        /** @type {?} */
        const exludeKeys = config && hasValue(config.excludeKeys) ? config.excludeKeys : [];
        return keys.reduce((/**
         * @param {?} acc
         * @param {?} key
         * @return {?}
         */
        function (acc, key) {
            if (acc && !keyIsExcludedIn(key, exludeKeys)) {
                if (isArray(tar[key])) {
                    if (includeArrays) {
                        /** @type {?} */
                        let isMatch = true;
                        for (let i = 0; i < tar[key].length; i++) {
                            if (isScalar(tar[key][i])) {
                                isMatch = src[key][i] === tar[key][i];
                            }
                            else {
                                isMatch = allValuesMatch(src[key][i], tar[key][i], config);
                            }
                            if (!isMatch) {
                                break;
                            }
                        }
                        return isMatch;
                    }
                    else {
                        return isDefined(src[key]) && isDefined(tar[key]);
                    }
                }
                else if (isScalar(tar[key])) {
                    return src[key] === tar[key];
                }
                else if (isPlainObject(tar[key])) {
                    return allValuesMatch(src[key], tar[key], config);
                }
                else if (isFunction(tar[key])) {
                    return isDefined(src[key]) && isDefined(tar[key]);
                }
                else {
                    return false;
                }
            }
            return acc;
        }), true);
    }
    else {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesTruthy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object to evaluate
 * @return {?}
 */
function allValuesTruthy(object) {
    if (isPlainObject(object)) {
        if (!isEmpty(object)) {
            return Object.keys(object).reduce((/**
             * @param {?} _allPropsHaveValue
             * @param {?} key
             * @return {?}
             */
            (_allPropsHaveValue, key) => {
                if (!_allPropsHaveValue) {
                    return _allPropsHaveValue;
                }
                return isTruthy(object[key]);
            }), true);
        }
        else {
            // _object is empty
            return false;
        }
    }
    else {
        // not plain _object
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/allValuesTruthyIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object to evaluate
 * @param {?} keys path to value such as a.b.c[2].d
 * @return {?}
 */
function allValuesTruthyIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return allValuesTruthy(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/keysAreTruthyInEntity.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} entity
 * @param {?} keys
 * @return {?}
 */
function keysAreTruthyInEntity(entity, keys) {
    return keysAreTruthyInCollection(values(entity), keys);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/copyExcludeKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T, R
 * @param {?} obj
 * @param {?} keys
 * @return {?}
 */
function copyExcludeKeys(obj, keys) {
    /** @type {?} */
    const _obj = clone(obj);
    return Object.keys(_obj).reduce((/**
     * @param {?} acc
     * @param {?} key
     * @return {?}
     */
    (acc, key) => {
        /** @type {?} */
        const found = keys.indexOf(key) > -1;
        if (!found) {
            acc[key] = _obj[key];
        }
        return acc;
    }), (/** @type {?} */ ({})));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/createObjectWithPaths.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Use Object with keys or _array with path notation 'a.b.c'
 * to create a javascript _object.
 * @param {?} paths _array or _string of path
 * @param {?=} value optional path
 * For example
 *
 * createObjectWithPaths('a.b.c', null);
 * // { a: { b: { c: null }}};
 * @return {?}
 */
function createObjectWithPaths(paths, value) {
    /** @type {?} */
    const _value = value ? value : null;
    if (isString(paths)) {
        return setIn({}, paths, _value);
    }
    else if (isArray(paths)) {
        return paths.reduce((/**
         * @param {?} obj
         * @param {?} _path
         * @return {?}
         */
        (obj, _path) => {
            if (isArray(_path)) {
                const [_pathInObj, _valueInObj] = (/** @type {?} */ (_path));
                return setIn(obj, _pathInObj, _valueInObj);
            }
            else {
                return setIn(obj, (/** @type {?} */ (_path)), _value);
            }
        }), {});
    }
    else if (isPlainObject(paths)) {
        return Object.keys(paths).reduce((/**
         * @param {?} _obj
         * @param {?} _path
         * @return {?}
         */
        (_obj, _path) => {
            return setIn(_obj, _path, paths[_path]);
        }), {});
    }
    else {
        return {};
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/keyConverter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} key
 * @return {?}
 */
function isArraySyntax(key) {
    if (!hasValue(key)) {
        return false;
    }
    // Note: indexOf and lastIndexOf is much faster than regex
    /** @type {?} */
    const hasFirstIndex = key.indexOf('[') === 0;
    /** @type {?} */
    const hasLastIndex = key.lastIndexOf(']') === key.length - 1;
    /** @type {?} */
    const _index = key.replace('[', '').replace(']', '');
    return hasFirstIndex && hasLastIndex && isArrayInteger(_index);
}
/**
 * For input as something like a _string '[23]', will receive the _number 23.
 * @param {?} key
 * @return {?}
 */
function getIndexAsNumber(key) {
    return parseInt(key.replace('[', '').replace(']', ''), 10);
}
/** @type {?} */
const arraySplitRegex = /\]\[/g;
/** @type {?} */
const propWithArrayRegex = /([a-zA-Z0-9])\[/g;
/**
 * Converts '[0][1][3].bar[10][0].FOO[100].bum'
 * into     '[0].[1].[3].bar.[10].[0].FOO.[100].bum'
 * @param {?} key
 * @return {?}
 */
function keySplitter(key) {
    return key.replace(arraySplitRegex, '].[').replace(propWithArrayRegex, '$1.[');
}
/**
 * @param {?} keys
 * @return {?}
 */
function splitKeysIntoDotNotation(keys) {
    if (isArray(keys)) {
        return map(keys, (/**
         * @param {?} _key
         * @return {?}
         */
        (_key) => {
            return keySplitter(_key);
        }));
    }
    else {
        return keySplitter((/** @type {?} */ (keys)));
    }
}
/**
 * Converts '[0][1][3].bar[10][0].FOO[100].bum'
 * into     [ 0, 1, 3, 'bar', 10, 0, 'FOO', 100, 'bum']
 * @param {?} key
 * @return {?}
 */
function keySplitterIntoImmutablePath(key) {
    if (!isArray(key)) {
        return keySplitter((/** @type {?} */ (key)))
            .split('.')
            .map((/**
         * @param {?} i
         * @return {?}
         */
        (i) => {
            if (isArraySyntax(i)) {
                return getIndexAsNumber(i);
            }
            return i;
        }));
    }
    else {
        // key is array
        return (/** @type {?} */ (key));
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/deleteIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @param {?} path
 * @return {?}
 */
function deleteNode(object, path) {
    /** @type {?} */
    const _path = keySplitterIntoImmutablePath(path);
    /** @type {?} */
    const _lastProp = _path.pop();
    // lastProp is a nested prop
    if (isLength(_path.length) && _path.length) {
        // parent _object
        /** @type {?} */
        const obj = getIn(object, _path);
        if (hasValue(obj)) {
            if (isArray(obj) && isNumber(_lastProp)) {
                obj.splice(Number(_lastProp));
            }
            else {
                // remove last prop from parent _object
                delete obj[_lastProp];
            }
            // place parent _object back in tree
            // if obj is not empty after removing target node
            if (hasValue(obj)) {
                setIn(object, _path, obj);
            }
        }
    }
    else {
        // _lastProp is at the root level of the _object,
        // just delete it.
        delete object[_lastProp];
    }
    return object;
}
/**
 * @param {?} object to be mutated
 * @param {?} path must be in dot notation: 'a.b.c' or [ 'a.b.c', 'a.d[0]' ]
 * @return {?}
 */
function deleteIn(object, path) {
    if (path === undefined || path === null) {
        throw new Error('deleteIn: _object path must have a value.');
    }
    if (isArray(path)) {
        return ((/** @type {?} */ (path))).reduce((/**
         * @param {?} _obj
         * @param {?} _path
         * @return {?}
         */
        (_obj, _path) => {
            return deleteNode(_obj, _path);
        }), clone(object));
    }
    else {
        return deleteNode(clone(object), (/** @type {?} */ (path)));
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/objectTransform.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @deprecated
 * @param {?} srcObj
 * @param {?} map
 * @return {?}
 */
function objectTransform(srcObj, map) {
    if (isPlainObject(srcObj) && isPlainObject(map)) {
        if (!isEmpty(srcObj) && !isEmpty(map)) {
            return Object.keys(map).reduce((/**
             * @param {?} acc
             * @param {?} key
             * @return {?}
             */
            (acc, key) => {
                acc = setIn(acc, key, getIn(srcObj, map[key], null));
                return acc;
            }), {});
        }
        else {
            // is plain _object but are empty
            // objects
            return {};
        }
    }
    else {
        // plain _object is empty
        return {};
    }
}
/**
 * @template T
 * @param {?} srcObj
 * @param {?} map
 * @return {?}
 */
function objectTransformMap(srcObj, map) {
    if (isPlainObject(srcObj) && isPlainObject(map) && !isEmpty(srcObj) && !isEmpty(map)) {
        return Object.keys(map).reduce((/**
         * @param {?} tarObj
         * @param {?} srcKey
         * @return {?}
         */
        (tarObj, srcKey) => {
            if (isString(map[srcKey])) {
                /** @type {?} */
                const targetKey = map[srcKey];
                tarObj = setIn(tarObj, targetKey, getIn(srcObj, srcKey, null));
            }
            else if (Array.isArray(map[srcKey])) {
                for (let i = 0; i < map[srcKey].length; i++) {
                    /** @type {?} */
                    const targetKey = map[srcKey][i];
                    tarObj = setIn(tarObj, targetKey, getIn(srcObj, srcKey, null));
                }
            }
            return tarObj;
        }), {});
    }
    else {
        // plain _object is empty
        return {};
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/differenceObject.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @param {?} base
 * @return {?}
 */
function differenceObject(object, base) {
    return objectTransform(object, (/**
     * @param {?} result
     * @param {?} value
     * @param {?} key
     * @return {?}
     */
    function (result, value, key) {
        if (!isEqual(value, base[key])) {
            result[key] = isObject(value) && isObject(base[key]) ? differenceObject(value, base[key]) : value;
        }
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/interfaceHasValueIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * In an _object that has nested nodes of a _common interface,
 * Return truthy of all _common properties hasValue.
 *
 * @param {?} object
 * @param {?} basePath is a path to an _object and may be a path such as 'a.b.c[0]' etc.
 * @param {?} keyOrPath can by a property key, or path to property key
 * @return {?}
 */
function interfaceHasValueIn(object, basePath, keyOrPath) {
    /** @type {?} */
    const t = {};
    if (hasIn(object, basePath)) {
        /** @type {?} */
        const baseObj = getIn(object, basePath, object);
        forIn(baseObj, (/**
         * @param {?} o
         * @param {?} oKey
         * @return {?}
         */
        (o, oKey) => {
            // to keep unique keys for truthy _object
            /** @type {?} */
            const concatPath = `${basePath}.${oKey}.${keyOrPath}`;
            t[concatPath] = getIn(o, keyOrPath);
        }));
        return allValuesHasValue(t);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/interfaceTruthyIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Return truthy of all _common properties in different paths.
 * @param {?} object
 * @param {?} basePath is a path to an _object and may be a path such as 'a.b.c[0]' etc.
 * @param {?} keyOrPath can by a property key, or path to property key
 * @return {?} boolean
 */
function interfaceTruthyIn(object, basePath, keyOrPath) {
    /** @type {?} */
    const t = {};
    if (hasIn(object, basePath)) {
        /** @type {?} */
        const baseObj = getIn(object, basePath, object);
        forIn(baseObj, (/**
         * @param {?} o
         * @param {?} oKey
         * @return {?}
         */
        (o, oKey) => {
            // to keep unique keys for truthy _object
            /** @type {?} */
            const concatPath = `${basePath}.${oKey}.${keyOrPath}`;
            t[concatPath] = getIn(o, keyOrPath);
        }));
        return allValuesTruthy(t);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/invokeIfElseIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Call value into target function if value exists
 *
 *  If you have:
 * if (target && target.prop && target.prop.prop2 {
 *    someFunction( target.prop && target.prop.prop2 );
 * } else {
 *    someFunction( defaultValue );
 * }
 *
 * Then you can use:
 * invokeIfElseIn(target, 'prop.prop2', defaultValue, someFunction);
 *
 * @param {?} object
 * @param {?} keys
 * @param {?} elseValue
 * @param {?} fn
 * @param {?=} context
 * @return {?}
 */
function invokeIfElseIn(object, keys, elseValue, fn, context = null) {
    /** @type {?} */
    const valueFromObject = ternaryIn(object, keys, elseValue);
    if (hasValue(valueFromObject)) {
        fn.call(context, valueFromObject);
    }
    else {
        fn.call(context, elseValue);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/invokeIfElseInConfig.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IInvokeIfElseIn() { }
if (false) {
    /** @type {?} */
    IInvokeIfElseIn.prototype.src;
    /** @type {?} */
    IInvokeIfElseIn.prototype.keys;
    /** @type {?} */
    IInvokeIfElseIn.prototype.elseValue;
    /** @type {?} */
    IInvokeIfElseIn.prototype.fn;
    /** @type {?|undefined} */
    IInvokeIfElseIn.prototype.context;
}
/**
 * Call value into target function if value exists
 *
 *  If you have:
 * if (target && target.prop && target.prop.prop2 {
 *    someFunction( target.prop && target.prop.prop2 );
 * } else {
 *    someFunction( defaultValue );
 * }
 *
 * Then you can use:
 * invokeIfElseIn(target, 'prop.prop2', defaultValue, someFunction);
 *
 * @param {?} config
 * @return {?}
 */
function invokeIfElseInConfig(config) {
    invokeIfElseIn(config.src, config.keys, config.elseValue, config.fn, config.context);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/invokeIfIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Call value into target function if value exists
 *
 * If you have:
 * if (target && target.prop && target.prop.prop2 {
 *    someFunction( target.prop && target.prop.prop2 );
 * }
 *
 * Then you can use:
 * invokeIfIn(target, 'prop.prop2', someFunction);
 *
 * @param {?} src
 * @param {?} keys
 * @param {?} fn
 * @param {?=} context
 * @return {?}
 */
function invokeIfIn(src, keys, fn, context = null) {
    /** @type {?} */
    const _value = getIn(src, keys);
    if (hasValue(_value)) {
        fn.call(context, _value);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/invokeIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Invokes the function nested at the provided path of keys, if it exists,
 * and returns the _object. The given keys may be an _array, or a dot-delimited
 * _string of properties. invokeIn accepts a variable _number of arguments to
 * be passed. If a function at the key does not exist, the _object is simply
 * returned.
 *
 * @param {?} object
 * @param {?} keys
 * @param {?=} args
 * @param {?=} context
 * @return {?}
 */
function invokeIn(object, keys, args, context = null) {
    /** @type {?} */
    let fn;
    if (typeof keys === 'undefined' || !hasValue(object)) {
        return object;
    }
    fn = getIn(object, keys);
    if (typeof fn !== 'function') {
        return object;
    }
    fn.apply(context, args);
    return object;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/isDefinedIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Returns whether or not the nested property is defined. Keys may be an
 * _array, or a dot-delimited _string of properties.
 *
 * @param {?} object
 * @param {?} keys
 * @return {?} boolean
 */
function isDefinedIn(object, keys) {
    if (hasIn(object, keys)) {
        /** @type {?} */
        const value = getIn(object, keys);
        return isDefined(value);
    }
    return false;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/keysHaveValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @param {?=} keys
 * @return {?}
 */
function keysHaveValue(value, keys) {
    if (isPlainObject(value)) {
        if (!isEmpty(value)) {
            if (keys && keys.length) {
                /** @type {?} */
                let allPropsHaveValue = true;
                /** @type {?} */
                const length = keys.length;
                for (let i = 0; i < length; i++) {
                    /** @type {?} */
                    const _key = keys[i];
                    /** @type {?} */
                    const _value = value[_key];
                    allPropsHaveValue = hasValue(_value);
                    if (!allPropsHaveValue) {
                        break;
                    }
                }
                return allPropsHaveValue;
            }
            else {
                // is plain _object but not keys provided
                // and _object is not empty
                return false;
            }
        }
        else {
            // plain _object is empty
            return false;
        }
    }
    else {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/objectMethodAssign.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} method
 * @param {?} update
 * @return {?}
 */
function assignMethod(method, update) {
    return (/**
     * @param {?} source
     * @return {?}
     */
    function (source) {
        return method(source, update);
    });
}
/**
 * @record
 * @template T
 */
function ObjectMethodAssign() { }
if (false) {
    /** @type {?} */
    ObjectMethodAssign.prototype.pipe;
}
/**
 * @template T
 * @param {?} target
 * @return {?}
 */
function objectMethodAssign(target) {
    return {
        pipe: (/**
         * @param {...?} methods
         * @return {?}
         */
        function (...methods) {
            return methods.reduce((/**
             * @param {?} a
             * @param {?} method
             * @return {?}
             */
            (a, method) => {
                return method(a);
            }), target);
        }),
    };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/searchObjectByKeys.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Search Object by property keys. If a key matches,
 * return results _array of objects of IFindPropertiesResult type:
 * [{
 *   key: 'searchKey',
 *   path: 'path.to.result',
 *   data: 'result node value'
 * }]
 *
 *
 * @param {?} node
 * @param {?} _searchParam
 * @param {?=} path
 * @return {?}
 */
function searchObjectByKeys(node, _searchParam, path = '') {
    /** @type {?} */
    let tempPath = '';
    if (isArray(node)) {
        return ((/** @type {?} */ (node))).reduce((/**
         * @param {?} result
         * @param {?} item
         * @param {?} index
         * @return {?}
         */
        (result, item, index) => {
            return result.concat(searchObjectByKeys(item, _searchParam, path + '[' + index + ']'));
        }), []);
    }
    else {
        return Object.keys(node).reduce((/**
         * @param {?} result
         * @param {?} key
         * @return {?}
         */
        (result, key) => {
            tempPath = path.length ? '.' + key : key;
            if (isArray(_searchParam)) {
                if (isObject(node[key]) || isArray(node[key])) {
                    result = result.concat(searchObjectByKeys(node[key], _searchParam, path + tempPath));
                }
                else {
                    if (_searchContains(_searchParam, key) && hasValue(node[key])) {
                        /** @type {?} */
                        const _result = _findPropertiesResultObject();
                        _result.key = key;
                        // concat path if recursion
                        _result.path = path + tempPath;
                        _result.data = node[key];
                        result.push(_result);
                    }
                }
            }
            else if (isFunction(_searchParam)) {
                // Call function on every node
                /** @type {?} */
                const _callResultTruthy = _searchParam.apply(null, [node[key], key]);
                if (_callResultTruthy) {
                    /** @type {?} */
                    const _result = _findPropertiesResultObject();
                    _result.key = key;
                    _result.path = path + tempPath;
                    _result.data = node[key];
                    result.push(_result);
                }
                if (isObject(node[key])) {
                    result = result.concat(searchObjectByKeys(node[key], _searchParam, path + tempPath));
                }
            }
            return result;
        }), []);
    }
}
/**
 * @ignore
 * @return {?}
 */
function _findPropertiesResultObject() {
    return {
        key: '',
        path: '',
        data: '',
    };
}
/**
 * @ignore
 * @param {?} collection
 * @param {?} search
 * @return {?}
 */
function _searchContains(collection, search) {
    return collection.indexOf(search) > -1;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/searchValuesByMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFindPropsWithValueResult() { }
if (false) {
    /** @type {?} */
    IFindPropsWithValueResult.prototype.search;
    /** @type {?} */
    IFindPropsWithValueResult.prototype.path;
    /** @type {?} */
    IFindPropsWithValueResult.prototype.data;
}
/**
 *
 * @param {?} node
 * @param {?} _searchMap map of property value pairs
 *
 * Example: {
 *    prop1: val1,
 *    prop2: val2
 * }
 *
 * @param {?=} path
 * @return {?}
 */
function searchValuesByMatch(node, _searchMap, path = '') {
    /** @type {?} */
    let result = [];
    /**
     * If node is _array, iterate over every _object
     */
    if (Array.isArray(node)) {
        node.map((/**
         * @param {?} item
         * @param {?} index
         * @return {?}
         */
        (item, index) => {
            result = result.concat(searchValuesByMatch(item, _searchMap, path + '[' + index + ']'));
        }));
        // map(node, (item: any, index: _number) => {
        //   result = result
        //     .concat(findPropsWithValue(item, _searchMap, (path + '[' + index + ']')));
        // });
    }
    else {
        /**
         * if _searchMap is found in node,
         * add as a result
         */
        if (ixIsMatch(node, _searchMap)) {
            /** @type {?} */
            const _result = _buildResult(node, _searchMap, path);
            result.push(_result);
        }
        else {
            /**
             * No match on current node,
             * so iterate over every property key
             * and recurse through values ( objects, arrays)
             * @type {?}
             */
            let tempPath = '';
            for (const _prop in node) {
                if (node.hasOwnProperty(_prop)) {
                    // concat . in path if recursion
                    tempPath = path.length ? '.' + _prop : _prop;
                    if (isObject(node[_prop]) || Array.isArray(node[_prop])) {
                        result = result.concat(searchValuesByMatch(node[_prop], _searchMap, path + tempPath));
                    }
                    // else {
                    //
                    //
                    //   if (isMatch(_searchMap, (_prop)) && hasValue(node[_prop])) {
                    //     const _result: IFindPropsWithValueResult = _resultObject();
                    //     _result.key = _prop;
                    //
                    //     // concat path if recursion
                    //     _result.path = path + tempPath;
                    //     _result.data = node[_prop];
                    //
                    //     result.push(_result);
                    //   }
                    //
                    // }
                }
            }
        }
    }
    return result;
}
/**
 * @ignore
 * @return {?}
 */
function _resultObject() {
    return {
        search: null,
        path: '',
        data: '',
    };
}
/**
 * @ignore
 * @param {?} data
 * @param {?} _searchMap
 * @param {?} _path
 * @return {?}
 */
function _buildResult(data, _searchMap, _path) {
    /** @type {?} */
    const _result = _resultObject();
    _result.search = _searchMap;
    _result.path = _path;
    _result.data = data;
    return _result;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/updateIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Updates the nested key with the given value, if it exists, and returns the
 * _object. Keys may either be an _array, or a dot-delimited _string of
 * properties. If a key does not exist, the _object is simply returned.
 *
 * @param {?} object
 * @param {?} keys
 * @param {?} value
 * @return {?}
 */
function updateIn(object, keys, value) {
    /** @type {?} */
    let i;
    /** @type {?} */
    let length;
    /** @type {?} */
    let current;
    if (typeof keys === 'undefined' || !hasValue(object)) {
        return object;
    }
    if (!isArray(keys)) {
        keys = splitKeysIntoDotNotation(keys);
        keys = ('' + keys).split('.');
    }
    current = object;
    length = keys.length;
    if (isArray(object) && isArraySyntax(keys[0])) {
        /** @type {?} */
        const index = getIndexAsNumber(keys[0]);
        // if _object exists in _array
        if (hasValue(object[index])) {
            // Are we drilling to _object in _array
            if (keys[1]) {
                object[index] = updateIn(object[index], keys.splice(1), value);
            }
            else {
                object[index] = value;
            }
            // return _object;
        }
        return object;
    }
    else {
        for (i = 0; i < length; i++) {
            if (!hasValue(current[keys[i]])) {
                return object;
            }
            if (keys[i + 1]) {
                if (isArraySyntax(keys[i + 1])) {
                    current[keys[i]] = updateIn(current[keys[i]], keys.splice(i + 1), value);
                    break;
                }
                else {
                    current = current[keys[i]];
                }
            }
            else {
                current[keys[i]] = value;
            }
        }
        return object;
    }
    // current = _object;
    // length = keys.length;
    //
    // // Iterate and return if a property is undefined
    // for (i = 0; i < length; i++) {
    //   if (!(keys[i] in current)) {
    //     return _object;
    //   }
    //
    //   if (i < length - 1) {
    //     current = current[keys[i]];
    //   }
    // }
    //
    // current[keys[i - 1]] = value;
    //
    // return _object;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/upSetIn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const upSetIn = setIn;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/valuesContainString.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} data
 * @param {?} q
 * @param {?} props
 * @return {?}
 */
function valuesContainString(data, q, props) {
    props = props && props.length ? props : [];
    q = q.toLowerCase();
    return props.reduce((/**
     * @param {?} _allPropsHaveValue
     * @param {?} key
     * @return {?}
     */
    (_allPropsHaveValue, key) => {
        if (_allPropsHaveValue) {
            return _allPropsHaveValue;
        }
        /** @type {?} */
        let item = getIn(data, key);
        if (hasValue(item) && isString(item)) {
            item = item.toLowerCase();
            q = q.toLowerCase();
            if (item.indexOf(q) > -1) {
                return true;
            }
        }
        return _allPropsHaveValue;
    }), false);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/valuesHaveValue.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @param {?=} keys
 * @return {?}
 */
function valuesHaveValue(object, keys) {
    if (isPlainObject(object)) {
        if (!isEmpty(object)) {
            if (keys && keys.length) {
                return keys.reduce((/**
                 * @param {?} _allPropsHaveValue
                 * @param {?} key
                 * @return {?}
                 */
                (_allPropsHaveValue, key) => {
                    if (!_allPropsHaveValue) {
                        return _allPropsHaveValue;
                    }
                    return hasValue(object[key]);
                }), true);
            }
            else {
                // is plain _object but not keys provided
                // and _object is not empty
                return false;
            }
        }
        else {
            // plain _object is empty
            return false;
        }
    }
    else {
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/valuesMatch.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Determine if similar keys in two different objects
 * have the same value.
 * @param {?} src source _object
 * @param {?} tar compare _object
 * @param {?} keys keys to compare
 * @return {?}
 */
function valuesMatch(src, tar, keys) {
    return keys.reduce((/**
     * @param {?} acc
     * @param {?} key
     * @return {?}
     */
    (acc, key) => {
        if (acc) {
            return src[key] === tar[key];
        }
        return acc;
    }), true);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_object/valuesWithKey.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} obj
 * @param {?} key
 * @return {?}
 */
function valuesWithKey(obj, key) {
    if (isPlainObject(obj) && hasValue(obj) && hasValue(key)) {
        return Object.keys(obj).reduce((/**
         * @param {?} acc
         * @param {?} _key
         * @return {?}
         */
        (acc, _key) => {
            if (isPlainObject(obj[_key])) {
                acc.push(Object.assign({ [key]: _key }, obj[_key]));
            }
            return acc;
        }), []);
    }
    else {
        return Object.keys(obj).reduce((/**
         * @param {?} acc
         * @param {?} _key
         * @return {?}
         */
        (acc, _key) => {
            if (isPlainObject(obj[_key])) {
                acc.push(Object.assign({}, obj[_key]));
            }
            return acc;
        }), []);
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_predicate/isSimpleChange.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} changes
 * @param {?} property
 * @return {?}
 */
function isSimpleChange(changes, property) {
    return changes.hasOwnProperty(property) && changes[property].previousValue !== changes[property].currentValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_string/starts-or-ends-with-whitespace.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright UIUX Engineering All Rights Reserved.
 */
/**
 * @param {?} str
 * @return {?}
 */
function startsOrEndsWithWhitespace(str) {
    return /^\s|\s$/.test(str);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_util/getFileExtension.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * Get the extension of a file name.
 *
 * https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript/1203361#1203361
 *
 * @param {?} filename
 * @return {?}
 */
function getFileExtension(filename) {
    return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/_util/getFileName.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} filepath
 * @return {?}
 */
function getFileName(filepath) {
    return filepath.substring(0, filepath.lastIndexOf('.')) || filepath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: uiux-fn.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { allValuesDefined, allValuesDefinedIn, allValuesHasValue, allValuesHasValueIn, allValuesMatch, allValuesTruthy, allValuesTruthyIn, arraySplitRegex, assignMethod, atLeast, clone, collectionItemsHaveValue, constant, copyExcludeKeys, createObjectWithPaths, dayToMs, deburr, deleteIn, difference, differenceBy, differenceObject, eq, findIndex, forIn, getFileExtension, getFileName, getIn, getIndexAsNumber, getRandomFromArray, getRandomRangeFromArray, hasIn, hasValue, hasValueEqual, hasValueEqualIn, hasValueEqualTo, hasValueIn, hasValueNotEqual, hasValueNotEqualIn, hourToMs, identity, includes, interfaceHasValueIn, interfaceTruthyIn, invokeIfElseIn, invokeIfElseInConfig, invokeIfIn, invokeIn, isArguments, isArray, isArrayInteger, isArrayLike, isArrayLikeObject, isArraySyntax, isBoolean, isBuffer, isDate, isDefined, isDefinedIn, isEmpty, isEqual, isFunction, isInteger, isLength, isMatch, isNull, isNumber, isObject, isObjectLike, isPlainObject, isPostiveInteger, isScalar, isSimpleChange, isString, isSymbol, isTruthy, isTruthyIn, isTypedArray, isUndefined, ixIsMatch, kebabCase, keySplitter, keySplitterIntoImmutablePath, keys, keysAreTruthy, keysAreTruthyInCollection, keysAreTruthyInEntity, keysHaveValue, keysIn, last, map, memoize, merge, mergeIn, mergePropsIfNoValue, mergePropsIfSourceHasValue, mergeWith, mergeWithoutArray, minToMs, msToDays, msToHours, msToMins, msToSec, objectMethodAssign, objectTransform, objectTransformMap, promise, propWithArrayRegex, propsWithNoValue, pullAllBy, randomInt, removeAllBy, searchObjectByKeys, searchValuesByMatch, secToMs, setIn, setInIfSrc, setInIfSrcWithConfig, shuffle, sortBy, splitKeysIntoDotNotation, startsOrEndsWithWhitespace, stubArray, stubFalse, symbol, ternary, ternaryIn, toFinite, toInteger, toNumber, toPlainObject, toString, transform, trim, uniq, uniqBy, uniqWith, uniqueId, upSetIn, updateIn, uuid, values, valuesContainString, valuesHaveValue, valuesMatch, valuesWithKey, words, baseRest as ɵa, setToString as ɵb, getNative as ɵba, createAssigner as ɵbb, basePullAll as ɵbc, baseIteratee as ɵbd, baseSet as ɵbe, copyObject as ɵbf, baseUniq as ɵbg, baseValues as ɵbh, arrayMap as ɵbi, shortOut as ɵc, baseSetToString as ɵd, defineProperty as ɵe, overRest as ɵf, baseFor as ɵg, createBaseFor as ɵh, castFunction as ɵi, arrayLikeKeys as ɵj, baseKeysIn as ɵk, hasPath as ɵl, baseHasIn as ɵm, baseIsArguments as ɵn, baseGetTag as ɵo, root as ɵp, freeGlobal as ɵq, nodeUtil as ɵr, baseUnary as ɵs, baseIsDate as ɵt, baseIsEqual as ɵu, baseIsMatch as ɵv, getMatchData as ɵw, baseIsTypedArray as ɵx, createCompounder as ɵy, baseKeys as ɵz };

